const messages = {
  ko: {
    translations: {
      seller_queue: {
        modal: {
          sale_outcome: {
            completed: '판매 완료',
            not_completed: '판매 미완료',
          },
          reasons: {
            label: '판매 미완료 이유:',
            loading: '이유를 불러오는 중...',
            load_error: '이유를 불러올 수 없습니다. 다시 시도하십시오.',
            retry: '다시 시도',
            placeholder: '이유를 선택하십시오...',
          },
          buttons: {
            cancel: '취소',
            next: '다음 →',
          },
        },
        "seller_queue": "판매자 큐",
        "queue_status": "큐 상태",
        "queue_position": "큐 내 위치",
        "queue_duration": "기간",
        "queue_seller_status": "판매자 상태",
        "queue_in_service": "서비스 중",
        "queue_not_in_service": "서비스 외",
        "queue_no_entry": "큐에 들어가 있지 않습니다",
        "queue_loading": "불러오는 중...",
        "queue_error": "오류: {{error}}",
        "queue_view_details": "세부 정보 보기",
        "reason": "이유",
      },
      gridHotelFeedback: {
        dashboard: '대시보드',
        service_grid: '설문 및 만족도 그리드',
        service_grid_single: '설문 및 만족도 그리드',
        listed_grids: '설문 및 만족도 그리드는 아래에 나열되어 있습니다',
        create_service_grid: '설문 및 만족도 그리드 생성',
        title: '제목',
        status: '상태',
        grid_deleted: '그리드가 삭제되었습니다!',
        grid_deleted_message: '설문 및 만족도 그리드가 성공적으로 삭제되었습니다.',
        error: '오류',
        error_delete_message: '설문 및 만족도 그리드를 삭제하는 동안 오류가 발생했습니다.',
        service_grid_name: '제목',
        service_grid_name_placeholder: '예: 만족도 설문조사',
        fill_information_create:
          '아래 정보를 입력하고 생성 버튼을 클릭하여 변경 사항을 저장하십시오',
        missing_fields: '필수 필드',
        missing_fields_message: '"제목" 필드와 "항목 목록"은 필수입니다!',
        grid_created: '그리드가 등록되었습니다',
        grid_created_message: '등록이 성공적으로 완료되었습니다!',
        error_create_message: '그리드를 등록하는 동안 오류가 발생했습니다!',
        service_list: '항목 목록',
        service_placeholder: '항목 추가 (예: 객실 품질)',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: '설문 및 만족도 그리드 수정',
        save_changes_edit: '아래 정보를 입력하고 저장 버튼을 클릭하여 변경 사항을 확인하십시오',
        grid_updated: '그리드가 변경되었습니다',
        grid_updated_message: '수정이 성공적으로 완료되었습니다!',
        error_update_message: '그리드를 변경하는 동안 오류가 발생했습니다!',

        general: {
          actions: '작업',
          edit: '수정',
          delete: '삭제',
          active: '활성',
          inactive: '비활성',
          select: '선택',
          back: '뒤로',
        },
        buttons: {
          create: '생성',
          back: '뒤로',
          save: '저장',
        },
      },
      // 상점 언어 관리 페이지 번역
      translate_stores: {
        page_title: '상점 언어 및 관계 관리',
        page_subtitle: '시스템 내 각 상점의 번역 언어 및 관계를 관리합니다.',
        page_title_relationships: '상점 관계 관리',
        page_subtitle_relationships: '시스템 내 상점 간의 관계를 관리합니다.',
        tab_translations: '언어 관리',
        tab_relations: '상점 관계',
        breadcrumb: {
          dashboard: '대시보드',
          translate_stores: '언어 관리',
        },
        filters: {
          status: '상태',
          type: '유형',
          active: '활성',
          inactive: '비활성',
          both: '둘 다',
          all_types: '모두',
          status_placeholder: '상점 상태',
          type_placeholder: '상점 유형',
          filter_button: '필터',
        },
        status_options: {
          active: '활성',
          inactive: '비활성',
          both: '둘 다',
          all_types: '모두',
        },
        languages: {
          portuguese: '포르투갈어',
          spanish: '스페인어',
          english: '영어',
          french: '프랑스어',
          german: '독일어',
          italian: '이탈리아어',
          japanese: '일본어',
          korean: '한국어',
          chinese: '만다린 오렌지',
        },
        table: {
          headers: {
            type: '유형',
            id: 'ID',
            name: '이름',
            subdomain: '하위 도메인',
            status: '상태',
            created: '생성일',
            cnpj: 'CNPJ',
            actions: '작업',
          },
          type: '유형',
          id: 'ID',
          name: '이름',
          subdomain: '하위 도메인',
          status: {
            active: '활성',
            inactive: '비활성',
          },
          created: '생성일',
          cnpj: 'CNPJ',
          actions: '작업',
        },
        actions: {
          manage_languages: '언어 관리',
          edit: '편집',
        },
        messages: {
          success: {
            title: '성공',
            save: '언어 저장 성공!',
          },
          error: {
            title: '오류',
            load_data: '상점 데이터 로드 중 오류 발생!',
            save_languages: '언어 저장 중 오류 발생!',
          },
        },
        modal: {
          title: '언어 관리',
          description: '이 상점에서 번역에 사용할 수 있는 언어를 선택하십시오:',
          alert: {
            title: '주의',
            message: '이 상점에서 번역에 사용해야 하는 언어를 활성화하거나 비활성화합니다.',
          },
          buttons: {
            cancel: '취소',
            save: '저장',
          },
        },
        relations: {
          no_relations: '관계가 없습니다.',
          create_title: '관계 생성',
          edit_title: '관계 편집',
          parent_label: '부모 상점',
          child_label: '자식 상점',
          parent_missing: '부모 상점을 선택하십시오',
          child_missing: '자식 상점을 선택하십시오',
          same_store_error: '부모 상점은 자식 상점과 같을 수 없습니다',
          created_success: '관계 생성 성공',
          updated_success: '관계 업데이트 성공',
          deleted_success: '관계 삭제 성공',
          error_create: '관계 생성 중 오류 발생',
          error_update: '관계 업데이트 중 오류 발생',
          error_delete: '관계 삭제 중 오류 발생',
          store_not_found: '상점을 찾을 수 없습니다',
          all_option: '모두',
          cancel: '취소',
          save: '저장',
          delete_confirm: '예, 삭제',
          create_button: '관계 생성',
          save_changes: '변경 사항 저장',
          create_description:
            '어떤 상점이 부모 상점이 되고 어떤 상점이 자식 상점이 될지 정의합니다. 부모 상점은 여러 자식 상점을 가질 수 있으며 해당 구성을 관리할 수 있습니다.',
          edit_description: '선택한 상점 간의 관계를 편집합니다. 변경 사항은 즉시 적용됩니다.',
          summary_title: '관계 요약:',
          tips_title: '중요 팁:',
          tip_parent_multiple: '부모 상점은 여러 자식 상점을 가질 수 있습니다',
          tip_child_single: '자식 상점은 여러 부모를 가질 수 있습니다',
          tip_all_available: '모든 상점(활성 및 비활성)을 선택할 수 있습니다',
          click_new: '"새 관계"를 클릭하여 시작하십시오',
          message_delete: '이 관계를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
        },
      },
      hospitality_review: {
        page_title: '호텔 평가',
        page_subtitle: '호텔 투숙객의 평가 및 등급을 관리하고 모니터링합니다.',
        breadcrumb: {
          dashboard: '대시보드',
          hospitality: '접객',
          reviews: '평가',
        },
        statistics: {
          total_reviews: '총 평가 수',
          average_rating: '전체 평균',
        },
        filters: {
          filter_by_type: '유형별 필터링',
          filter_by_rating: '평가별 필터링',
        },
        type_options: {
          all_types: '모두',
          general: '일반',
          room: '객실',
          food: '음식',
          service: '서비스',
          cleanliness: '청결도',
          activities: '활동',
        },
        rating_options: {
          all_ratings: '모든 평가',
          five_stars: '5 별',
          four_stars: '4 별',
          three_stars: '3 별',
          two_stars: '2 별',
          one_star: '1 별',
        },
        table: {
          headers: {
            rating: '평가',
            type: '유형',
            comment: '댓글',
            date: '날짜',
            actions: '작업',
          },
          actions: {
            view_full_review: '전체 평가 보기',
          },
          status: {
            approved: '승인됨',
            pending: '대기 중',
          },
        },
        modal: {
          review_title: '평가:',
          fields: {
            rating: '평가',
            type: '유형',
            status: '상태',
            date: '날짜',
            comment: '댓글',
            email: '이메일',
          },
          guest_anonymous: '익명',
        },
        messages: {
          success: {
            review_deleted: '평가 삭제됨',
            delete_success: '삭제 성공!',
            status_updated: '상태 업데이트됨',
            approved_success: '평가 승인 성공!',
            suspended_success: '평가 일시 중단 성공!',
          },
          error: {
            title: '오류',
            load_reviews: '호텔 평가 로드 중 오류 발생!',
            invalid_id: '삭제할 ID가 유효하지 않습니다!',
            delete_error: '평가 삭제 중 오류 발생!',
            status_error: '평가 상태 변경 중 오류 발생!',
          },
          confirm: {
            delete_title: '삭제 확인',
            delete_text: '이 평가를 삭제하시겠습니까?',
            delete_confirm: '예, 삭제',
            delete_cancel: '취소',
          },
        },
      },
      hospitality_info: {
        page_title: '호텔 정보',
        page_subtitle: '호텔 연락처, 시간 및 서비스를 관리합니다.',
        tabs: {
          contact: '연락처',
          hours: '시간 및 정보',
          services: '서비스',
          ramal: '내선',
          about: '소개',
        },
        contact: {
          phone_label: '전화',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: '이메일',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          title: '호텔 시간 및 정보',
          add_button: '시간/정보 추가',
          remove_button: '제거',
          hour_number: '항목',
          title_label: '제목',
          title_placeholder: '예: 접수, 수영장, 레스토랑',
          description_label: '시간 및 정보',
          description_placeholder:
            '영업 시간 및 추가 정보를 설명하십시오 (예: 08:00 - 22:00, 주말 휴무)',
        },
        services: {
          title: '호텔 서비스',
          add_button: '서비스 추가',
          remove_button: '제거',
          service_number: '서비스',
          service_title_label: '서비스 제목',
          service_title_placeholder: '예: 룸 서비스',
          service_description_label: '설명',
          service_description_placeholder: '서비스를 설명하십시오',
        },
        ramal: {
          title: '호텔 내선',
          add_button: '내선 추가',
          remove_button: '제거',
          ramal_number: '내선',
          ramal_title_label: '내선 제목',
          ramal_title_placeholder: '예: 504',
          ramal_description_label: '설명',
          ramal_description_placeholder: '내선을 설명하십시오',
        },
        about: {
          description_label: '호텔 소개',
          description_placeholder:
            '호텔에 대한 일반 정보, 역사, 고유한 특징 및 특별한 특성을 설명하십시오',
        },
        actions: {
          save_button: '저장',
        },
        messages: {
          error_title: '오류',
          error_text: '호텔 정보를 저장할 수 없습니다.',
          success_title: '저장됨!',
          success_text: '호텔 정보 저장 성공.',
          required_phone: '전화는 필수입니다.',
          required_email: '이메일은 필수입니다.',
          required_hours: '모든 항목에는 제목과 설명이 있어야 합니다.',
          required_service: '모든 서비스에는 제목과 설명이 있어야 합니다.',
          required_ramal: '모든 내선에는 제목과 설명이 있어야 합니다.',
        },
      },
      hospitality_schedules: {
        page_title: '호텔 프로그램',
        page_subtitle: '호텔 이벤트 및 프로그램을 관리합니다.',
        new_button: '새 프로그램',
        edit_button: '프로그램 편집',
        delete_button: '프로그램 삭제',
        delete_confirm: '이 프로그램을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
        table: {
          title: '제목',
          type: '유형',
          location: '장소',
          time: '시간',
          recurrence: '반복',
          period: '기간',
          status: '상태',
          actions: '작업',
          active: '활성',
          inactive: '비활성',
          single_event: '단일 이벤트',
          all_types: '모두',
          all_status: '모든 상태',
          age_group: '연령대',
        },
        filters: {
          type: '유형',
          type_placeholder: '유형 선택',
          status: '상태',
          status_placeholder: '상태 선택',
          date_init: '시작일',
          date_init_placeholder: '시작일',
          date_end: '종료일',
          date_end_placeholder: '종료일',
          search: '검색',
          clear: '필터 지우기',
        },
        messages: {
          load_error: '프로그램 로드 중 오류 발생!',
          delete_success: '프로그램 삭제 성공!',
          delete_error: '프로그램 삭제 중 오류 발생!',
        },
        types: {
          activity: '엔터테인먼트',
          food: '미식',
          event: '이벤트',
          tour: '여행',
        },
        age_groups: {
          all: '모든 사람',
          children: '어린이',
          teens: '청소년',
          adults: '성인',
          seniors: '노인',
          family: '가족',
        },
        singleEvent: '단일 이벤트',
      },
      hospitality_schedule_edit: {
        page_title: '프로그램 편집',
        page_subtitle: '편집 중: {{title}}',
        not_found: {
          title: '프로그램을 찾을 수 없습니다',
          description: '편집하려는 프로그램을 찾을 수 없습니다.',
          back_button: '목록으로 돌아가기',
        },
        form: {
          type_label: '유형',
          type_placeholder: '유형 선택',
          type_sports: '스포츠',
          type_wellness: '웰빙',
          type_other: '기타',
          title_label: '제목',
          title_placeholder: '프로그램 제목 입력',
          description_label: '설명',
          description_placeholder: '프로그램 설명',
          location_label: '장소',
          location_placeholder: '프로그램 장소',
          time_label: '시간',
          time_placeholder: '예: 14:00 - 16:00 또는 14:00',
          time_smalltext: '형식: "HH:MM - HH:MM" 또는 "HH:MM"',
          recurrence_config: '반복 구성',
          single_event_radio: '단일 이벤트 - 특정 날짜에 발생하는 이벤트',
          recurring_event_radio: '반복 이벤트 - 매주 특정 요일에 반복되는 이벤트',
          days_of_week_label: '요일',
          selected_days: '선택됨: {{days}}',
          date_init_label: '시작일',
          date_init_placeholder: '시작일',
          date_end_label: '종료일',
          date_end_placeholder: '종료일 (선택 사항)',
          status_label: '상태',
          back_button: '뒤로',
          save_button: '변경 사항 저장',
        },
      },
      hospitality_schedule_create: {
        page_title: '새 프로그램',
        page_subtitle: '호텔 새 프로그램 생성',
        success: {
          title: '성공!',
          text: '프로그램 생성 성공!',
        },
        error: {
          title: '오류',
          text: '프로그램 생성 중 오류 발생!',
        },
        form: {
          title_label: '제목 *',
          title_placeholder: '프로그램 제목 입력',
          title_required: '제목은 필수입니다',
          type_label: '유형 *',
          type_placeholder: '유형 선택',
          type_sports: '스포츠',
          type_wellness: '웰빙',
          type_other: '기타',
          description_label: '설명 *',
          description_placeholder: '프로그램 설명',
          description_required: '설명은 필수입니다',
          location_label: '장소 *',
          location_placeholder: '프로그램 장소',
          location_required: '장소는 필수입니다',
          time_label: '시간 *',
          time_placeholder: '예: 14:00 - 16:00 또는 14:00',
          time_smalltext: '형식: "HH:MM - HH:MM" 또는 "HH:MM"',
          time_required: '시간은 필수입니다',
          recurrence_config: '반복 구성',
          single_event_radio: '단일 이벤트 - 특정 날짜에 발생하는 이벤트',
          recurring_event_radio: '반복 이벤트 - 매주 특정 요일에 반복되는 이벤트',
          days_of_week_label: '요일',
          selected_days: '선택됨: {{days}}',
          date_init_label: '시작일',
          date_init_placeholder: '시작일',
          date_end_label: '종료일',
          date_end_placeholder: '종료일 (선택 사항)',
          status_label: '상태',
          back_button: '뒤로',
          save_button: '저장',
        },
      },
      hospitality_banner: {
        page_title: '호텔 배너',
        page_subtitle: '호텔 배너를 관리합니다. 표시 기간, 순서, 상태를 제어합니다.',
        breadcrumb: {
          hospitality: '접객',
          publicity: '홍보',
        },
        new_button: '새 홍보',
        table: {
          title: '제목',
          image: '이미지',
          order: '순서',
          period: '기간',
          created_date: '생성일',
          status: '상태',
          actions: '작업',
        },
        actions: {
          edit: '홍보 편집',
          view: '세부 정보 보기',
          delete: '홍보 삭제',
        },
        modal: {
          title: '홍보 #{{id}}',
          order: '순서',
          status: '상태',
          active: '활성',
          inactive: '비활성',
          period: '기간',
          created: '생성일',
          updated: '최종 업데이트',
          image: '이미지',
          no_image: '이미지 없음',
        },
        delete: {
          confirm_title: '삭제 확인',
          confirm_text: '이 홍보를 삭제하시겠습니까?',
          confirm_button: '예, 삭제',
          cancel_button: '취소',
          success_title: '홍보 삭제됨',
          success_text: '삭제 성공!',
        },
        status: {
          success_title: '상태 업데이트됨',
          success_text: '홍보 {{action}} 성공!',
          activated: '활성화됨',
          deactivated: '비활성화됨',
        },
        error: {
          title: '오류',
          load_data: '홍보 데이터 로드 중 오류 발생!',
          invalid_id: '삭제할 ID가 유효하지 않습니다!',
          delete: '홍보 삭제 중 오류 발생!',
          status_change: '홍보 상태 변경 중 오류 발생!',
        },
      },
      hospitality_banner_create: {
        page_title: '새 호텔 배너 생성',
        page_subtitle: '새 배너를 생성하려면 아래 정보를 작성하십시오.',
        breadcrumb: {
          hospitality: '접객',
          publicity: '홍보',
          create: '홍보 생성',
        },
        form: {
          title_label: '배너 제목 *',
          title_placeholder: '예: 하이킹...',
          order_label: '표시 순서 *',
          order_placeholder: '예: 1, 2, 3...',
          order_smalltext: '홍보 우선 순서 (숫자가 낮을수록 먼저 표시)',
          status_label: '활성 홍보',
          status_smalltext: '체크하여 홍보를 활성화합니다',
          start_date_label: '시작일 *',
          start_time_label: '시작 시간 *',
          end_date_label: '종료일 *',
          end_time_label: '종료 시간 *',
          image_label: '홍보 이미지',
          image_select: '이미지 선택',
          image_formats: '허용되는 형식: JPG, PNG, GIF',
          image_optional: '선택 사항 - 제공되지 않으면 기본 이미지가 사용됩니다',
          image_preview: '이미지 미리보기',
          image_remove: '이미지 제거',
        },
        preview: {
          period_title: '홍보 기간:',
          start: '시작',
          end: '종료',
        },
        validation: {
          title: '유효성 검사 오류',
          order_positive: '순서는 0보다 큰 숫자여야 합니다!',
          start_date_required: '시작일은 필수입니다!',
          end_date_required: '종료일은 필수입니다!',
          dates_required: '날짜 및 시간은 필수입니다!',
          start_before_end: '시작일은 종료일보다 이전이어야 합니다!',
        },
        success: {
          title: '홍보 생성됨',
          text: '홍보 생성 성공!',
        },
        error: {
          title: '오류',
          text: '홍보 생성 중 오류 발생!',
        },
      },
      hospitality_banner_update: {
        page_title: '호텔 홍보 편집',
        page_subtitle: '홍보 #{{id}} 편집',
        breadcrumb: {
          edit: '홍보 편집',
        },
        current_image: '현재 이미지',
        save_button: '변경 사항 저장',
        not_found: {
          title: '홍보를 찾을 수 없습니다',
          text: '편집하려는 홍보를 찾을 수 없습니다.',
          back_button: '목록으로 돌아가기',
        },
        no_changes: {
          title: '변경 사항 없음',
          text: '변경 된 필드가 없습니다!',
        },
        success: {
          title: '홍보 업데이트됨',
          text: '홍보 업데이트 성공!',
        },
        error: {
          title: '오류',
          text: '홍보 업데이트 중 오류 발생',
          load_data: '홍보 데이터 로드 중 오류 발생!',
          update: '홍보 업데이트 중 오류 발생!',
        },
      },
      hospitality_publicity: {
        page_title: '호텔 하이라이트 배너',
        page_subtitle: '호텔 하이라이트 배너를 관리합니다. 표시 기간, 순서, 상태를 제어합니다.',
        breadcrumb: {
          hospitality: '접객',
          publicity: '홍보',
        },
        new_button: '새 배너',
        table: {
          image: '이미지',
          order: '순서',
          period: '기간',
          created_date: '생성일',
          status: '상태',
          actions: '작업',
        },
        actions: {
          edit: '홍보 편집',
          view: '세부 정보 보기',
          delete: '홍보 삭제',
        },
        modal: {
          title: '홍보 #{{id}}',
          order: '순서',
          status: '상태',
          active: '활성',
          inactive: '비활성',
          period: '기간',
          created: '생성일',
          updated: '최종 업데이트',
          image: '이미지',
          no_image: '이미지 없음',
        },
        delete: {
          confirm_title: '삭제 확인',
          confirm_text: '이 홍보를 삭제하시겠습니까?',
          confirm_button: '예, 삭제',
          cancel_button: '취소',
          success_title: '홍보 삭제됨',
          success_text: '삭제 성공!',
        },
        status: {
          success_title: '상태 업데이트됨',
          success_text: '홍보 {{action}} 성공!',
          activated: '활성화됨',
          deactivated: '비활성화됨',
        },
        error: {
          title: '오류',
          load_data: '홍보 데이터 로드 중 오류 발생!',
          invalid_id: '삭제할 ID가 유효하지 않습니다!',
          delete: '홍보 삭제 중 오류 발생!',
          status_change: '홍보 상태 변경 중 오류 발생!',
        },
      },
      hospitality_publicity_create: {
        page_title: '호텔 홍보 생성',
        page_title_edit: '호텔 홍보 편집',
        page_subtitle: '새 홍보를 생성하려면 아래 정보를 작성하십시오.',
        breadcrumb: {
          hospitality: '접객',
          publicity: '홍보',
          create: '홍보 생성',
        },
        form: {
          order_label: '표시 순서 *',
          order_placeholder: '예: 1, 2, 3...',
          order_smalltext: '홍보 우선 순서 (숫자가 낮을수록 먼저 표시)',
          status_label: '활성 홍보',
          status_smalltext: '체크하여 홍보를 활성화합니다',
          start_date_label: '시작일 *',
          start_time_label: '시작 시간 *',
          end_date_label: '종료일 *',
          end_time_label: '종료 시간 *',
          image_label: '홍보 이미지',
          image_select: '이미지 선택',
          image_formats: '허용되는 형식: JPG, PNG, GIF | 크기: ~200x112px | 최대 용량: 2MB',
          image_optional: '선택 사항 - 제공되지 않으면 기본 이미지가 사용됩니다',
          image_preview: '이미지 미리보기',
          image_remove: '이미지 제거',
          external_link_checkbox: '외부 링크 포함',
          external_link_label: '외부 링크',
          external_link_placeholder: 'https://example.com',
          description_label: '배너 설명',
          description_smalltext: '* 최대 {qtd} 문자',
          title_label: '배너 제목',
          title_placeholder: '예: 하이킹...',
          title_smalltext: '* 최대 {qtd} 자',
        },
        preview: {
          period_title: '홍보 기간:',
          start: '시작',
          end: '종료',
        },
        validation: {
          title: '유효성 검사 오류',
          order_positive: '순서는 0보다 큰 숫자여야 합니다!',
          start_date_required: '시작일은 필수입니다!',
          end_date_required: '종료일은 필수입니다!',
          dates_required: '날짜 및 시간은 필수입니다!',
          start_before_end: '시작일은 종료일보다 이전이어야 합니다!',
          external_link_required: '옵션이 선택된 경우 외부 링크는 필수입니다!',
          image_size_error: '이미지 크기는 최대 2MB여야 합니다!',
          image_dimensions_error: '이미지 크기는 약 200x112픽셀이어야 합니다! 현재: {{current}}',
          image_invalid: '유효하지 않은 이미지 파일입니다! 유효한 이미지를 선택해주세요.',
        },
        success: {
          title: '홍보 생성됨',
          text: '홍보 생성 성공!',
        },
        error: {
          title: '오류',
          text: '홍보 생성 중 오류 발생!',
          update: '홍보 업데이트 중 오류 발생!',
        },
        not_found: {
          title: '홍보를 찾을 수 없습니다',
          text: '편집하려는 홍보를 찾을 수 없습니다.',
          back_button: '목록으로 돌아가기',
        },
        no_changes: {
          title: '변경 사항 없음',
          text: '변경 된 필드가 없습니다!',
        },
        current_image: '현재 이미지',
      },
      // 파일에 추가
      service_list: {
        filters: {
          categories: '카테고리',
          category_placeholder: '카테고리',
          filter_button: '필터',
          all_categories: '모두',
        },
        table: {
          schedule: '일정',
          extension: '내선',
        },
        actions: {
          delete_service: '서비스 삭제',
        },
      },
      // 파일에 추가
      service_create: {
        page_title: '서비스 등록',
        breadcrumb: {
          services: '서비스',
          create: '생성',
        },
        form: {
          classification_placeholder: '분류 선택',
          name_label: '이름',
          name_placeholder: '서비스 이름',
          description_label: '설명',
          description_placeholder: '서비스 설명',
          schedule_label: '운영 시간',
          schedule_placeholder: '예: 24시간, 08:00-18:00, 요청 시',
          schedule_smalltext: '최대 50자',
          extension_label: '내선',
          extension_placeholder: '예: 1001, 2050',
          extension_smalltext: '최대 10자',
          code_label: '코드',
          code_placeholder: '서비스 코드',
          order_label: '순서',
          order_placeholder: '표시 순서',
          status_label: '상태',
          status_active: '활성',
          status_inactive: '비활성',
          external_link_label: '외부 링크',
          external_link_placeholder: 'https://example.com',
          priority_label: '우선순위',
          priority_low: '낮음',
          priority_normal: '보통',
          priority_high: '높음',
          priority_critical: '긴급',
        },
        icons: {
          title: '아이콘',
          category_label: '아이콘 카테고리',
          all_categories: '모두',
          selected_icon: '선택된 아이콘',
        },
        validation: {
          missing_fields_title: '누락된 필드',
          missing_fields_text: '모든 필수 필드(이름, 분류, 아이콘)를 작성했는지 확인하십시오!',
        },
        success: {
          title: '서비스 등록됨',
          text: '등록 성공!',
        },
        error: {
          title: '오류',
          text: '서비스 등록 중 오류 발생!',
          icons_load: '유형 찾기 중 오류 발생',
        },
      }, // 파일에 추가
      service_update: {
        page_title: '서비스 편집',
        page_title_full: '서비스 업데이트',
        breadcrumb: {
          edit: '편집',
        },
        error: {
          title: '오류',
          load_data: '서비스 데이터 로드 중 오류 발생!',
          text: '서비스 업데이트 중 오류 발생!',
        },
        success: {
          title: '서비스 업데이트됨',
          text: '편집 성공!',
        },
      },
      // 파일에 추가
      service_category_create: {
        validation: {
          missing_fields_title: '누락된 필드',
          missing_fields_text: '모든 필드를 작성했는지 확인하십시오!',
        },
        success: {
          title: '분류 등록됨',
          text: '등록 성공!',
        },
        error: {
          title: '오류',
          text: '분류 등록 중 오류 발생!',
          create: '분류 등록 중 오류 발생!',
        },
      },

      // 파일에 추가
      service_category_list: {
        page_title: '콘텐츠 카테고리',
        page_subtitle: '여기에 콘텐츠 카테고리와 각 작업이 나열됩니다.',
        breadcrumb: {
          categories: '카테고리',
        },
        add_button: '추가',
        table: {
          name: '이름',
          status: '상태',
          actions: '작업',
        },
        actions: {
          edit_category: '카테고리 편집',
          delete_category: '카테고리 삭제',
        },
        delete: {
          error_title: '오류',
          error_text: '카테고리 삭제 중 오류 발생!',
          success_title: '카테고리 삭제됨',
          success_text: '삭제 성공!',
          confirm_title: '확실합니까?',
          confirm_text: '카테고리가 삭제되며 복원할 수 없습니다!',
          cancel_button: '닫기!',
          confirm_button: '삭제!',
        },
      },
      service_category_update: {
        error: {
          title: '오류',
          load_data: '분류 데이터 로드 중 오류 발생!',
          text: '분류 업데이트 중 오류 발생!',
          update: '분류 업데이트 중 오류 발생!',
        },
        success: {
          title: '분류 업데이트됨',
          text: '편집 성공!',
        },
      },
      hotelRoom: {
        status: {
          available: '이용 가능',
          reserved: '예약됨',
          maintenance: '정비 중',
          occupied: '사용 중',
          being_cleaning: '청소 중',
        },
        type: {
          single: '싱글룸',
          double: '더블룸',
          twin: '트윈룸',
          queen: '퀸룸',
          king: '킹룸',
          suite: '스위트룸',
          junior_suite: '주니어 스위트',
          master_suite: '마스터 스위트',
          presidential: '프레지덴셜 스위트',
          family: '패밀리룸',
          accessible: '장애인 친화 객실',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: '고객',
          wizard_step_reservation: '예약',
          wizard_step_confirmation: '확인',
          wizard_step1: '1단계',
          wizard_step2: '2단계',
          wizard_step3: '3단계',
          wizard_customer_title: '고객 선택 또는 등록',
          wizard_customer_search_placeholder: '이름, 이메일 또는 전화번호로 검색...',
          wizard_customer_search_button: '기존 고객 검색',
          wizard_customer_new_button: '새 고객 등록',
          wizard_customer_none_found: '고객을 찾을 수 없습니다',
          wizard_customer_showing_first:
            '처음 20개 결과를 표시합니다. 검색을 구체화하여 다른 고객을 찾으십시오.',
          wizard_reservation_title: '예약 데이터',
          wizard_reservation_room_label: '객실 *',
          wizard_reservation_room_subtitle:
            '객실을 클릭하여 선택합니다. 여러 객실을 선택할 수 있습니다.',
          wizard_reservation_room_placeholder: '객실 선택',
          wizard_reservation_status_label: '예약 상태',
          wizard_reservation_status_placeholder: '상태 선택',
          wizard_reservation_checkin_label: '체크인 날짜 및 시간 *',
          wizard_reservation_checkout_label: '체크아웃 날짜 및 시간 *',
          wizard_reservation_password_label: '고객 비밀번호',
          wizard_reservation_password_placeholder: '고객 비밀번호 입력',
          wizard_reservation_generate_password: '비밀번호 생성',
          wizard_confirmation_title: '예약 확인',
          wizard_confirmation_customer_data: '고객 데이터',
          wizard_confirmation_reservation_data: '예약 데이터',
          wizard_confirmation_room: '객실',
          wizard_confirmation_capacity: '수용 인원',
          wizard_confirmation_price: '가격',
          wizard_confirmation_checkin: '체크인',
          wizard_confirmation_checkout: '체크아웃',
          wizard_confirmation_status: '상태',
          wizard_confirmation_password: '비밀번호',
          wizard_confirmation_address: '주소',
          wizard_confirmation_zipcode: '우편번호',
          wizard_confirmation_gender_male: '남성',
          wizard_confirmation_gender_female: '여성',
          wizard_confirmation_gender_other: '기타',
          wizard_confirmation_gender_not_informed: '알리고 싶지 않음',
          wizard_buttons_back: '뒤로',
          wizard_buttons_cancel: '취소',
          wizard_buttons_next: '다음',
          wizard_buttons_create: '생성',
          wizard_page_title: '새 객실 예약',
          wizard_page_subtitle: '호텔 새 예약 생성',
          legend: {
            title: '객실 상태 범례',
            available: '사용 가능',
            selected: '선택됨',
            unavailable: '사용 불가능',
            occupied: '점유 중',
            reserved: '예약됨',
            being_cleaning: '청소 중',
            maintenance: '유지 보수 중',
            no_info: '정보 없음',
          },
        },
        customer_form: {
          title: '고객 데이터',
          personal_info_title: '개인 정보',
          cpf_label: 'CPF *',
          cpf_placeholder: '000.000.000-00',
          name_label: '전체 이름 *',
          name_placeholder: '전체 이름 입력',
          email_label: '이메일 *',
          email_placeholder: '이메일 입력',
          birthdate_label: '생년월일 *',
          gender_label: '성별',
          gender_placeholder: '성별 선택',
          gender_male: '남성',
          gender_female: '여성',
          gender_other: '기타',
          contact_info_title: '연락처 정보',
          phone_label: '전화 *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: '전화 유형',
          phone_type_cell: '휴대폰',
          phone_type_landline: '유선 전화',
          whatsapp_optin: 'WhatsApp 메시지 수신 동의',
          address_title: '거주지 주소',
          cep_label: '우편번호 *',
          cep_placeholder: '00000-000',
          street_label: '도로명 *',
          street_placeholder: '거리, 대로 등',
          number_label: '번호 *',
          number_placeholder: '123',
          extra_label: '추가',
          extra_placeholder: '아파트, 블록 등',
          district_label: '이웃 *',
          district_placeholder: '이웃 이름',
          city_label: '도시 *',
          city_placeholder: '도시 이름',
          state_label: '주 *',
          state_placeholder: 'SP',
          reference_label: '참조 지점',
          reference_placeholder: '쇼핑몰 근처, 광장 맞은편 등',
          terms_title: '이용 약관',
          accept_terms: '이용 약관에 동의합니다 *',
          lgpd_consent: '개인 데이터 처리에 동의합니다 (LGPD) *',
        },
        title: '객실 예약',
        subtitle: '호텔 예약 관리',
        breadcrumb_dashboard: '대시보드',
        breadcrumb_reservation: '예약',
        btn_new_reservation: '새 예약',
        btn_confirm: '예약 확인',
        btn_checkin: '체크인 진행',
        btn_checkout: '체크아웃 진행',
        btn_cancel: '예약 취소',
        btn_no_show: '미도착으로 표시',
        btn_delete: '예약 삭제',
        btn_details: '예약 세부 정보',
        filter_status_label: '예약 상태',
        filter_status_placeholder: '상태 선택',
        filter_status_all: '모든 상태',
        table_reservation: '예약',
        table_room: '객실',
        table_customer: '고객',
        table_checkin: '체크인',
        table_checkout: '체크아웃',
        table_status: '상태',
        table_price: '가격',
        table_actions: '작업',
        status_confirmed: '확인됨',
        status_in_progress: '진행 중',
        status_completed: '완료됨',
        status_cancelled: '취소됨',
        status_no_show: '미도착',
        status_pending: '대기 중',
        msg_success_delete: '삭제 성공!',
        msg_success_update: '예약 상태 업데이트 성공!',
        msg_error_delete: '예약 삭제 중 오류 발생!',
        msg_error_update: '예약 상태 업데이트 중 오류 발생!',
        msg_confirm_status_change: '예약 상태를 "{status}"(으)로 변경하시겠습니까?',
        msg_confirm_checkin: '이 예약에 대해 체크인을 진행하시겠습니까?',
        msg_confirm_checkout: '체크아웃을 완료하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
        msg_checkout_attention: '⚠️ 주의 - 자세히 읽어보십시오:',
        msg_checkout_list: [
          '고객이 이미 결제를 완료했습니다',
          '미결제 금융 문제가 없습니다',
          '모든 서비스가 정산되었습니다',
        ],
        msg_checkout_confirm_read: '모든 유효성 검사가 확인되었음을 읽고 확인합니다',
        msg_checkout_validation:
          '계속 진행하기 전에 모든 유효성 검사를 읽고 확인했음을 확인해야 합니다.',
        msg_confirm_delete: '예약 삭제',
        tab_basic: '기본 정보',
        tab_summary: '요약',
        tab_activities: '활동',
        tab_tours: '여행',
        tab_experiences: '체험',
        tab_services: '서비스 예약',
        tab_services_list: '서비스 목록',
        tab_orders: '호텔 주문',
        label_loading: '로드 중...',
        label_loading_orders: '주문 로드 중...',
        label_order_details: '주문 세부 정보',
        label_no_data: '주문을 찾을 수 없습니다',
        label_pending: '현재 예약된 주문이 없습니다.',
        tab_title: '호텔 주문',
        label_order: '주문',
        label_orders: '주문',
        label_total_spent: '총 지출: {value}',
        label_total_orders: '총 주문 수',
        label_total_spent_label: '총 지출',
        label_total_paid_label: '총 지불액',
        label_products: '제품',
        label_quantity: '수량',
        label_sku: 'SKU',
        label_delivery: '배송',
        label_delivery_address: '배송 주소',
        label_withdraw_address: '픽업 주소',
        label_financial_summary: '재무 요약',
        label_products_label: '제품',
        label_delivery_fee: '배송 수수료',
        label_discount: '할인',
        label_total: '합계',
        label_payment_na: '결제 N/A',
        label_payment_offline: '오프라인 결제',
        label_payment_card: '카드 결제',
        label_payment_credit: '신용',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: '기본 정보',
          label_customer: '고객',
          label_room: '객실',
          label_checkin: '체크인',
          label_checkout: '체크아웃',
          label_status: '상태',
          label_price: '가격',
          label_notes: '비고',
          placeholder_notes: '예약 비고 추가',
          status_edit_warning: '예약 상태는 확인 또는 취소 후 편집할 수 없습니다.',
          selected_room_details: '객실 {roomNumber} - {type} (수용 인원: {capacity}) - R$ {price}',
          selected_customer_details: '고객: {name} | 이메일: {email} | 전화: {phone}',
          optional_checkout: '체크아웃은 선택 사항이며 나중에 작성할 수 있습니다.',
          status_pending: '대기 중',
          status_confirmed: '확인됨',
          status_in_progress: '진행 중',
          status_completed: '완료됨',
          status_cancelled: '취소됨',
          summary_capacity: '수용 인원',
          summary_people: '명',
          btn_change_password: '비밀번호 변경',
        },
        summary: {
          tab_title: '요약',
          room_details: '객실 세부정보',
          label_total: '합계',
          label_paid: '지불됨',
          label_pending: '대기 중',
          label_services: '서비스',
          label_products: '제품',
          label_activities: '활동',
          label_experiences: '체험',
          label_tours: '여행',
          label_room: '객실',
          label_customer: '고객',
          label_checkin: '체크인',
          label_checkout: '체크아웃',
          label_status: '상태',
          label_price: '가격',
          label_notes: '비고',
          label_capacity: '수용 인원',
          label_people: '명',
          label_orders: '호텔 주문',
          label_payment_method: '결제 수단',
          label_discount: '할인',
          label_tax: '세금',
          label_total_with_tax: '세금 포함 합계',
          label_total_with_discount: '할인 포함 합계',
          label_total_paid: '총 지불액',
          label_total_pending: '총 미결제액',
          label_summary: '예약 요약',
          label_details: '세부 정보',
          label_edit: '편집',
          label_delete: '삭제',
          label_confirm: '확인',
          label_cancel: '취소',
          label_no_data: '사용 가능한 데이터 없음',
          label_success: '작업 성공!',
          label_error: '작업 중 오류 발생!',
          label_warning: '주의',
          label_info: '정보',
          label_actions: '작업',
          label_service: '서비스',
          label_product: '제품',
          label_activity: '활동',
          label_experience: '체험',
          label_tour: '여행',
          label_order: '주문',
          label_date: '날짜',
          label_time: '시간',
          label_type: '유형',
          label_edit_reservation: '예약 편집',
          label_delete_reservation: '예약 삭제',
          label_confirm_reservation: '예약 확인',
          label_cancel_reservation: '예약 취소',
          label_status_confirmed: '확인됨',
          label_status_in_progress: '진행 중',
          label_status_completed: '완료됨',
          label_status_cancelled: '취소됨',
          label_status_no_show: '미도착',
          label_status_pending: '대기 중',
        },
        activities: {
          tab_title: '활동',
          label_activity: '활동',
          label_activities: '활동',
          label_no_data: '활동을 찾을 수 없습니다',
          label_pending: '현재 예약된 활동이 없습니다.',
          label_people: '참가자',
          label_category: '카테고리',
          label_location: '위치',
          label_session_time: '세션 시간',
          label_skill_level: '능력 수준',
          label_special_requests: '특별 요청',
          label_price: '가격',
          label_date: '날짜',
          label_time: '시간',
          label_status: '상태',
          label_actions: '작업',
          label_description: '설명',
          status_confirmed: '확인됨',
          status_pending: '대기 중',
          status_cancelled: '취소됨',
          status_completed: '완료됨',
          btn_add_activity: '활동 추가',
        },
        experiences: {
          tab_title: '체험',
          label_experience: '체험',
          label_experiences: '체험',
          label_no_data: '체험을 찾을 수 없습니다',
          label_pending: '현재 예약된 체험이 없습니다.',
          label_people: '참가자',
          label_category: '카테고리',
          label_location: '위치',
          label_session_time: '세션 시간',
          label_skill_level: '능력 수준',
          label_special_requests: '특별 요청',
          label_price: '가격',
          label_date: '날짜',
          label_time: '시간',
          label_status: '상태',
          label_actions: '작업',
          label_description: '설명',
          status_confirmed: '확인됨',
          status_pending: '대기 중',
          status_cancelled: '취소됨',
          status_completed: '완료됨',
          btn_add_experience: '체험 추가',
          label_duration: '기간',
          label_rating: '평가',
          label_special_occasion: '특별한 날',
          label_includes: '포함',
        },
        hotel_orders: {
          tab_title: '호텔 주문',
          label_order: '주문',
          label_orders: '주문',
          label_no_data: '주문을 찾을 수 없습니다',
          label_pending: '현재 예약된 주문이 없습니다.',
          label_delivery: '배송',
          label_quantity: '수량',
          label_sku: 'SKU',
          label_delivery_address: '배송 주소',
          label_withdraw_address: '픽업 주소',
          label_financial_summary: '재무 요약',
          label_products: '제품',
          label_products_label: '제품',
          label_total_spent: '총 지출: {value}',
          label_total_orders: '총 주문 수',
          label_total_spent_label: '총 지출',
          label_total_paid_label: '총 지불액',
          label_discount: '할인',
          label_total: '합계',
          label_payment_na: '결제 N/A',
          label_payment_offline: '오프라인 결제',
          label_payment_card: '카드 결제',
          label_payment_credit: '신용',
          label_delivery_fee: '배송 수수료',
          no_order_title: '주문을 찾을 수 없습니다',
        },
        tours: {
          tab_title: '여행',
          label_tour: '여행',
          label_tours: '여행',
          label_no_data: '여행을 찾을 수 없습니다',
          label_pending: '현재 예약된 여행이 없습니다.',
          label_people: '참가자',
          label_duration: '기간',
          label_difficulty: '난이도',
          label_rating: '평가',
          label_transfer_included: '교통편 포함',
          label_transfer_yes: '이동 포함',
          label_transfer_no: '이동 불포함',
          label_schedule: '일정',
          label_weather_concerns: '날씨 우려',
          label_physical_requirements: '신체 요구 사항',
          label_special_requests: '특별 요청',
          label_price: '가격',
          label_date: '날짜',
          label_time: '시간',
          label_status: '상태',
          label_actions: '작업',
          label_description: '설명',
          status_confirmed: '확인됨',
          status_pending: '대기 중',
          status_cancelled: '취소됨',
          status_completed: '완료됨',
          btn_add_tour: '여행 추가',
        },
        services: {
          title: '서비스 예약',
          subtitle: '예약된 서비스 세부정보',
          no_services: '예약된 서비스가 없습니다',
          service_info: '서비스 정보',
          service_name: '서비스 이름',
          service_type: '서비스 유형',
          description: '설명',
          room_info: '객실 정보',
          room_number: '객실',
          booking_details: '예약 세부정보',
          status: '상태',
          check_in: '체크인',
          check_out: '체크아웃',
          guest_name: '게스트 이름',
          reservation_name: '예약 이름',
          number_of_rooms: '객실 수',
          number_of_guests: '게스트 수',
          adults: '성인',
          children: '어린이',
          total_price: '총 가격',
          price_per_night: '1박당 가격',
          nights: '박',
          additional_info: '추가 정보',
          booking_date: '예약 날짜',
          reservation_code: '예약 코드',
          payment_status: '결제 상태',
          special_requests: '특별 요청',
          service_details: '서비스 세부정보',
          view_details: '세부정보 보기',
          total_services: '총 서비스',
          active_services: '활성 서비스',
          pending_services: '대기 중인 서비스',
          completed_services: '완료된 서비스',
          service_image: '서비스 이미지',
          no_image: '이미지가 없습니다',
        },
        services_list: {
          title: '서비스 목록',
          subtitle: '모든 예약된 서비스',
          search_placeholder: '이름, 객실, 게스트로 검색...',
          filter_all: '전체',
          filter_active: '활성',
          filter_pending: '대기 중',
          filter_completed: '완료',
          table_service_name: '서비스',
          table_service_type: '유형',
          table_room: '객실',
          table_guest: '게스트',
          table_checkin: '체크인',
          table_checkout: '체크아웃',
          table_status: '상태',
          table_price: '가격',
          table_actions: '작업',
          status_active: '활성',
          status_pending: '대기 중',
          status_completed: '완료',
          status_cancelled: '취소됨',
          no_services: '서비스를 찾을 수 없습니다',
          no_services_desc: '기준에 맞는 서비스가 없습니다',
          showing: '표시 중',
          of: '/',
          services: '서비스',
          items_per_page: '페이지당 항목',
          page: '페이지',
          previous: '이전',
          next: '다음',
          view_details: '세부정보 보기',
          total_found: '총 발견',
          active_filters: '활성 필터',
          clear_filters: '필터 지우기',
          filter_by_status: '상태로 필터',
          search_active: '검색 활성',
          rooms: '객실',
          guests: '게스트',
          nights: '박',
          loading: '서비스 로드 중...',
          error: '서비스 로드 오류',
          retry: '다시 시도',
          export: '내보내기',
          refresh: '새로고침',
        },
      },
      hospitality_hotel_room: {
        label_room_number: '객실 번호 *',
        image: '객실 이미지',
        placeholder_room_number: '예: 101, A201, 프레지덴셜 스위트',
        max_20_chars: '최대 20자',
        label_status: '상태',
        label_capacity: '수용 인원 (명)',
        placeholder_capacity: '예: 2',
        label_price: '가격 (R$)',
        placeholder_price: '예: 150.00',
        label_type: '객실 유형',
        title: '호텔 객실',
        subtitle: '호텔 객실 관리',
        create_multiples: '여러 객실 생성',
        add_room: '객실 추가',
        header_number: '번호',
        header_status: '상태',
        header_type: '유형',
        header_capacity: '수용 인원',
        header_price: '가격',
        header_actions: '작업',
        action_edit: '객실 편집',
        action_delete: '객실 삭제',
        modal_bulk_title: '여러 객실 생성',
        modal_bulk_prefix: '접두사 (선택 사항)',
        modal_bulk_prefix_placeholder: '예: A, B, 1층',
        modal_bulk_start: '시작 번호 *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: '종료 번호 *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: '수용 인원',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: '가격',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: '유형',
        type_single: '싱글',
        type_double: '더블',
        type_twin: '트윈',
        type_queen: '퀸',
        type_king: '킹',
        type_suite: '스위트',
        type_junior_suite: '주니어 스위트',
        type_master_suite: '마스터 스위트',
        type_presidential: '프레지덴셜',
        type_family: '가족',
        type_accessible: '접근 가능',
        modal_bulk_cancel: '취소',
        modal_bulk_create: '객실 생성',
        breadcrumb_dashboard: '대시보드',
        breadcrumb_hotel_room: '호텔 객실',
        create_title: '호텔 객실 생성',
        create_subtitle: '호텔에 새 객실 추가',
        edit_title: '호텔 객실 편집',
        edit_subtitle: '객실 #{room} 정보 편집',
        breadcrumb_create: '객실 생성',
        breadcrumb_edit: '객실 편집',
      },
      hospitality_experiences: {
        tab_basic: '기본 정보',
        edit: '체험 편집',
        edit_subtitle: '체험 정보 업데이트',
        create: '체험 생성',
        create_subtitle: '새 체험을 생성하려면 세부 정보를 작성하십시오',
        tab_details: '세부 항목',
        tab_image: '이미지',
        tab_schedules: '일정',
        list_title: '호텔 체험',
        list_subtitle: '모든 호텔 체험 관리',
        field_title: '제목',
        field_title_placeholder: '예: 특별 로맨틱 디너',
        field_description: '설명',
        field_description_placeholder: '제공되는 체험을 자세히 설명하십시오...',
        field_image: '새 이미지',
        field_price: '가격 (R$)',
        field_price_placeholder: '0.00',
        field_duration: '기간',
        field_duration_placeholder: '예: 2시간',
        field_type: '체험 유형',
        field_rating: '평가 (0-5)',
        field_rating_placeholder: '0',
        field_status: '활성 상태',
        field_includes: '포함된 항목',
        field_includes_placeholder: '예: 샴페인, 특별 장식...',
        field_show_additional_services: '미리 정의된 서비스 옵션 표시',
        field_actions: '작업',
        status_active: '활성',
        status_inactive: '비활성',
        no_rating: '평가 없음',
        no_includes: '포함된 항목 없음',
        currency: 'R$',
        btn_add: '체험 추가',
        btn_edit: '편집',
        btn_delete: '제거',
        btn_update: '체험 업데이트',
        btn_create: '체험 생성',
        btn_remove: '제거',
        btn_add_item: '항목 추가',
        edit_title: '체험 편집',
        create_title: '체험 생성',
        msg_success_create: '체험 생성 성공!',
        msg_success_update: '체험 업데이트 성공!',
        msg_success_delete: '체험 제거됨',
        msg_success_delete_text: '체험 제거 성공!',
        msg_error_create: '체험 생성 중 오류 발생',
        msg_error_update: '체험 업데이트 중 오류 발생',
        msg_error_delete: '체험 제거 중 오류 발생',
        msg_error_delete_text: '체험을 제거할 수 없습니다!',
        msg_error_load: '체험 로드 중 오류 발생',
        msg_error_load_text: '체험 데이터를 로드할 수 없습니다!',
        msg_error_required_title: '제목은 필수입니다!',
        msg_error_title_length: '제목은 최대 255자여야 합니다!',
        msg_error_required_description: '설명은 필수입니다!',
        msg_error_required_price: '가격은 필수입니다!',
        msg_error_price_negative: '가격은 0보다 크거나 같아야 합니다!',
        msg_error_required_duration: '기간은 필수입니다!',
        msg_error_duration_length: '기간은 최대 100자여야 합니다!',
        msg_error_required_includes: '적어도 하나의 항목이 포함되어야 합니다!',
        msg_error_rating_range: '평가는 0에서 5 사이여야 합니다!',
        field_order: '순서',
        field_order_placeholder: '예: 1, 2, 3...',
        header_order: '순서',
        msg_error_order_negative: '순서는 0보다 크거나 같아야 합니다!',
      },
      entertainment_services: {
        list_title: '엔터테인먼트 서비스',
        list_subtitle: '사용 가능한 엔터테인먼트 서비스 관리',
        create: '엔터테인먼트 서비스 생성',
        create_subtitle: '새 서비스를 생성하기 위해 세부 정보를 입력하세요',
        create_title: '엔터테인먼트 서비스 생성',
        edit: '엔터테인먼트 서비스 편집',
        edit_subtitle: '서비스 정보 업데이트',
        edit_title: '엔터테인먼트 서비스 편집',
        field_title: '제목',
        field_title_placeholder: '예: 스파 및 마사지',
        field_type: '서비스 유형',
        field_status: '활성 상태',
        field_actions: '작업',
        type_experience: '엔터테인먼트 경험',
        type_activity: '엔터테인먼트 활동',
        type_tour: '엔터테인먼트 투어',
        status_active: '활성',
        status_inactive: '비활성',
        btn_add: '서비스 추가',
        btn_edit: '편집',
        btn_delete: '제거',
        btn_update: '서비스 업데이트',
        btn_create: '서비스 생성',
        btn_search: '검색',
        btn_clear: '지우기',
        search_placeholder: '제목으로 검색...',
        msg_success_create: '서비스가 성공적으로 생성되었습니다!',
        msg_success_update: '서비스가 성공적으로 업데이트되었습니다!',
        msg_success_delete: '서비스가 제거되었습니다',
        msg_success_delete_text: '서비스가 성공적으로 제거되었습니다!',
        msg_error_create: '서비스 생성 중 오류가 발생했습니다',
        msg_error_update: '서비스 업데이트 중 오류가 발생했습니다',
        msg_error_delete: '서비스 제거 중 오류가 발생했습니다',
        msg_error_delete_text: '서비스를 제거할 수 없습니다!',
        msg_error_load: '서비스 로드 중 오류가 발생했습니다',
        msg_error_load_text: '서비스 데이터를 로드할 수 없습니다!',
        msg_error_required_title: '제목은 필수입니다!',
        msg_error_title_length: '제목은 최대 255자여야 합니다!',
      },
      hospitality_activities: {
        hotel_reservation: {
          page_title: '서비스 예약',
          details_title: '예약 세부 정보',
          cancel_title: '예약 취소',
          cancel_reason_label: '취소 사유 *',
          cancel_reason_placeholder: '취소 사유 선택',
          cancel_reason_select: '사유 선택',
          type_tour: '여행',
          type_experience: '체험',
          type_activity: '활동',
          type_room_service: '룸 서비스',
          status_pending: '대기 중',
          status_confirmed: '확인됨',
          status_cancelled: '취소됨',
          status_completed: '완료됨',
          error_title: '오류',
          error_load: '예약 로드 중 오류 발생!',
          error_details: '예약 세부 정보 로드 중 오류 발생!',
          error_cancel: '예약 취소 중 오류 발생!',
          success_title: '성공',
          success_cancel: '예약 취소 성공!',
          warning_title: '주의',
          warning_cancel_reason: '취소 사유를 선택하십시오.',
          no_details: '이러한 유형의 예약에 대한 특정 세부 정보는 사용할 수 없습니다.',
          reasons_tour: ['계획 변경', '날씨 문제', '시간 충돌', '건강상의 이유', '호텔 취소'],
          reasons_experience: [
            '숙박 날짜 변경',
            '특별한 경우 취소됨',
            '일정 충돌',
            '개인적인 이유',
            '다른 서비스 선호',
          ],
          reasons_activity: [
            '준비가 안 된 느낌',
            '시간 충돌',
            '건강 문제',
            '계획 변경',
            '활동이 기대에 미치지 못함',
          ],
          reasons_room_service: [
            '계획 변경',
            '서비스 불필요',
            '시간 충돌',
            '개인적인 이유',
            '다른 서비스 선호',
          ],
        },
        create_title: '호텔 활동 생성',
        create_subtitle: '호텔에 새 활동 추가',
        edit_title: '호텔 활동 편집',
        edit_subtitle: '활동 정보 업데이트',
        list_title: '호텔 활동',
        list_subtitle: '활동 및 엔터테인먼트 관리',
        field_title: '활동 제목 *',
        field_title_placeholder: '예: 요가 수업, 뮤지컬 쇼, 어린이 레크리에이션',
        field_title_hint: '최대 255자',
        field_time: '시간 *',
        field_time_placeholder: '예: 08:00 - 09:00, 매일 15시',
        field_time_hint: '최대 100자',
        field_description: '설명 *',
        field_description_placeholder:
          '활동, 이점 및 투숙객이 기대할 수 있는 사항을 자세히 설명하십시오...',
        field_image: '활동 이미지',
        field_location: '위치 *',
        field_location_placeholder: '예: 메인 수영장, 이벤트 홀, 해변',
        field_location_hint: '최대 255자',
        field_capacity: '수용 인원 *',
        field_capacity_placeholder: '예: 20, 0이면 무제한',
        field_capacity_hint: '최대 50자',
        field_period: '기간 *',
        field_period_placeholder: '예: 00:15 또는 01:00 또는 00:30',
        field_category: '카테고리 *',
        field_age_group: '연령대',
        field_price: '가격 (R$)',
        field_price_placeholder: '0.00 (무료인 경우 비워 둠)',
        field_price_hint: '무료 활동인 경우 비워 둠',
        field_requires_reservation: '예약 필요',
        field_requires_reservation_hint: '사전 예약이 필요한 활동인 경우 체크',
        field_is_active: '활동 활성',
        field_is_active_hint: '체크를 해제하여 활동을 일시적으로 비활성화합니다',
        btn_edit: '활동 편집',
        btn_delete: '활동 삭제',
        btn_create: '활동 생성',
        btn_cancel: '취소',
        msg_success_create: '활동 생성 성공!',
        msg_success_update: '활동 업데이트 성공!',
        msg_success_delete: '활동 삭제 성공!',
        msg_error_create: '활동 생성 중 오류 발생!',
        msg_error_update: '활동 업데이트 중 오류 발생!',
        msg_error_delete: '활동 삭제 중 오류 발생!',
        msg_error_load: '활동 로드 중 오류 발생!',
        msg_error_required_title: '제목은 필수입니다!',
        msg_error_title_length: '제목은 최대 255자여야 합니다!',
        msg_error_required_description: '설명은 필수입니다!',
        msg_error_required_time: '시간은 필수입니다!',
        msg_error_time_length: '시간은 최대 100자여야 합니다!',
        msg_error_required_location: '위치는 필수입니다!',
        msg_error_location_length: '위치는 최대 255자여야 합니다!',
        msg_error_required_capacity: '수용 인원은 필수입니다!',
        msg_error_capacity_length: '수용 인원은 최대 50자여야 합니다!',
        msg_error_price_negative: '가격은 0보다 크거나 같아야 합니다!',
        remove_schedule: '일정 삭제',
        confirm_remove_schedule: '이 일정을 삭제하시겠습니까?',
        schedule_seasonal_start: '시즌 시작',
        schedule_seasonal_end: '시즌 종료',
        schedule_start_time: '시작 시간',
        schedule_end_time: '종료 시간',
        add_schedule: '일정 추가',
        schedule_time: '시간 *',
        schedule_time_placeholder: '예: 08:00 - 09:00, 매일 15시',
        schedule_description: '설명 *',
        schedule_days_of_week: '요일',
        schedule_status: '일정 활성',
        schedule_seasonal_hint: '해당되는 경우 계절 기간 정의',
        field_duration_hint: '시간과 분으로 기간 (예: 2h30min)',
        field_duration_placeholder: '시간과 분으로 기간 (예: 2h30min)',
        field_order: '순서',
        field_order_placeholder: '예: 1, 2, 3...',
        msg_error_order_negative: '순서는 0보다 크거나 같아야 합니다!',
      },
      hotel_tour: {
        create_title: '호텔 여행 생성',
        create_subtitle: '호텔에 새 여행 추가',
        edit_title: '호텔 여행 편집',
        edit_subtitle: '여행 정보 업데이트',
        list_title: '호텔 여행',
        list_subtitle: '여행 및 소풍 관리',
        field_title: '여행 제목 *',
        field_difficulty: '난이도',
        field_duration: '기간',
        field_rating: '평가',
        field_participants: '참가자',
        field_schedules: '일정',
        field_includes: '포함',
        field_transfer: '교통편',
        field_currency: '통화',
        field_currency_hint: '통화 코드 (예: BRL, USD)',
        currency_brl: '레알 (BRL)',
        currency_usd: '달러 (USD)',
        currency_eur: '유로 (EUR)',
        field_rating_placeholder: '0.0',
        field_rating_hint: '0에서 5점 사이의 평가',
        field_participants_min: '최소 참가자 *',
        field_participants_min_hint: '최소 참가자 수',
        field_participants_max: '최대 참가자',
        field_participants_max_placeholder: '무제한인 경우 비워 둠',
        field_participants_max_hint: '최대 참가자 수 (선택 사항)',
        field_age_restriction: '연령 제한',
        field_age_restriction_placeholder: '예: 12세 이상, 18세 미만에게는 권장되지 않음',
        field_age_restriction_hint: '연령 제한 (선택 사항)',
        field_physical_requirements: '신체 요구 사항',
        field_physical_requirements_placeholder: '예: 좋은 신체 상태, 장거리 걷기 능력',
        field_physical_requirements_hint: '필요한 신체 요구 사항 (선택 사항)',
        field_cancellation_hours: '취소 (시간) *',
        field_cancellation_hours_hint: '취소까지 남은 시간',
        field_discount_children: '어린이 할인 (%)',
        field_discount_children_hint: '백분율 할인',
        field_weather_dependent: '날씨 의존적',
        field_weather_dependent_hint: '기상 조건에 따라 달라지는 경우 체크',
        field_is_active: '여행 활성',
        field_is_active_hint: '체크를 해제하여 일시적으로 비활성화합니다',
        tab_basic: '기본 정보',
        tab_details: '세부 정보 및 구성',
        tab_schedules: '일정',
        tab_includes: '포함된 항목',
        tab_image: '이미지',
        no_schedule_added: '추가된 일정이 없습니다',
        click_add_schedule: '"일정 추가"를 클릭하여 시작하십시오.',
        includes_title: '여행에 포함된 항목',
        selected: '선택됨',
        field_image_hint: '여행을 대표하는 이미지를 선택합니다',
        update_info: '여행 정보 업데이트',
        field_title_placeholder: '예: 시티 투어, 해변 소풍, 역사 산책',
        field_title_hint: '최대 255자',
        field_time: '시간 *',
        field_time_placeholder: '예: 08:00 - 09:00, 매일 15시',
        field_time_hint: '최대 100자',
        field_description: '설명 *',
        field_description_placeholder:
          '여행, 하이라이트 및 투숙객이 기대할 수 있는 사항을 설명하십시오...',
        field_image: '여행 이미지',
        field_location: '위치 *',
        field_location_placeholder: '예: 센터, 해변, 박물관',
        field_location_hint: '최대 255자',
        field_capacity: '수용 인원 *',
        field_capacity_placeholder: '예: 20, 0이면 무제한',
        field_capacity_hint: '최대 50자',
        field_category: '카테고리 *',
        field_price: '가격 (R$)',
        field_price_placeholder: '0.00 (무료인 경우 비워 둠)',
        field_price_hint: '무료 여행인 경우 비워 둠',
        field_requires_reservation: '예약 필요',
        field_requires_reservation_hint: '사전 예약이 필요한 여행인 경우 체크',
        btn_edit: '여행 편집',
        btn_delete: '여행 삭제',
        btn_create: '여행 생성',
        btn_cancel: '취소',
        table_title: '제목',
        table_time: '시간',
        table_location: '위치',
        table_category: '카테고리',
        table_price: '가격',
        table_capacity: '수용 인원',
        table_actions: '작업',
        msg_success_create: '여행 생성 성공!',
        msg_success_update: '여행 업데이트 성공!',
        msg_success_delete: '여행 삭제 성공!',
        msg_error_create: '여행 생성 중 오류 발생!',
        msg_error_update: '여행 업데이트 중 오류 발생!',
        msg_error_delete: '여행 삭제 중 오류 발생!',
        msg_error_load: '여행 로드 중 오류 발생!',
        msg_error_required_title: '제목은 필수입니다!',
        msg_error_title_length: '제목은 최대 255자여야 합니다!',
        msg_error_required_description: '설명은 필수입니다!',
        msg_error_required_time: '시간은 필수입니다!',
        msg_error_time_length: '시간은 최대 100자여야 합니다!',
        msg_error_required_location: '위치는 필수입니다!',
        msg_error_location_length: '위치는 최대 255자여야 합니다!',
        msg_error_required_capacity: '수용 인원은 필수입니다!',
        msg_error_capacity_length: '수용 인원은 최대 50자여야 합니다!',
        msg_error_price_negative: '가격은 0보다 크거나 같아야 합니다!',
        schedule_start_time: '시작 시간',
        schedule_end_time: '종료 시간',
        add_schedule: '일정 추가',
        schedule_time: '시간 *',
        schedule_time_placeholder: '예: 08:00 - 09:00, 매일 15시',
        schedule_description: '설명 *',
        schedule_days_of_week: '요일',
        schedule_status: '일정 활성',
        schedule_seasonal_hint: '해당되는 경우 계절 기간 정의',
        field_duration_hint: '시간과 분으로 기간 (예: 2h30min)',
        field_duration_placeholder: '시간과 분으로 기간 (예: 2h30min)',
        schedule_seasonal_start: '시즌 시작',
        schedule_seasonal_end: '시즌 종료',
        difficult: {
          easy: '쉬움',
          medium: '보통',
          hard: '어려움',
          extreme: '극한',
        },
        field_order: '순서',
        field_order_placeholder: '예: 1, 2, 3...',
        header_order: '순서',
        msg_error_order_negative: '순서는 0보다 크거나 같아야 합니다!',
      },
      months: {
        jan: '1월',
        feb: '2월',
        mar: '3월',
        apr: '4월',
        may: '5월',
        jun: '6월',
        jul: '7월',
        aug: '8월',
        sep: '9월',
        oct: '10월',
        nov: '11월',
        dec: '12월',
      },
      permissions: {
        color_variations: '색상 변형',
        food: '스마트 오더',
        smartorder: '제품 관리',
        category: '카테고리',
        subcategory: '하위 카테고리',
        product: '제품',
        mark: '브랜드',
        grid: '그리드',
        variation: '변형',
        catalog: '카탈로그',
        integration: '통합',
        int_pos: 'POS',
        int_gateway: '결제 수단',
        messaging: '메시징',
        sms: '상태 및 SMS',
        multichannel: '다채널',
        report: '보고서',
        saleorder: '주문',
        indicators: '지표',
        orderReport: '주문',
        imports: '이미지 가져오기',
        importProductImage: '제품',
        importProductImageSKU: '변형',
        importCategoryImage: '카테고리',
        customers: '고객',
        customer_report: '고객 목록',
        measurement_unit: '측정 단위',
        logs: '로그',
        settings: '설정',
        charge_integration: '로드',
        summaryAccess: '액세스',
        sellerAccess: '판매자 대시보드',
        managerAccess: '관리자 대시보드',
        managerGroupAccess: '그룹 관리자 대시보드',
        orders: '주문',
        support: '지원',
        translate: '언어 및 관계',
        featuresPluginspace: '기능',
        application: '웹 앱',
        messenger: '메시징',
        others: '기타',
        settings_store: '상점 설정',
        settings_hotel: '설정 ',
        modalities: '모달리티',
        delivery_tax: '배송 수수료',
        shifts: '교대 근무',
        whatsappweb: 'WhatsApp 웹',
        filemanager: '파일 관리자',
        payment_plans: '결제 계획',
        settings_account: '계정 설정',
        account: '계정',
        groups: '그룹',
        users: '사용자',
        terms: '약관',
        highlights: '하이라이트',
        menu: '메뉴',
        productReport: '제품',
        optional: '추가 항목 목록',
        locations: '섹터',
        stores_location: '시설',
        message_hotel: '상태 및 알림',
        service: '서비스',
        service_items: '서비스',
        service_category: '카테고리',
        feed: '피드',
        content: '웹앱 인터페이스',
        buttons: '버튼',
        sessions: '세션',
        structured_content: '필수 서비스',
        orders_room_service: '객실 주문',
        orders_activities: '활동 주문',
        queue: '대기열',
        queue_config: '구성',
        queue_manager: '관리',
        reason: '이유',
        seller_queue_config: '판매자 대기열 구성',
        checkout: '고객 데이터',
        booking: '예약',
        booking_management: '관리',
        booking_config: '구성',
        booking_environment: '환경',
        booking_day: '당일 예약',
        booking_report: '보고서',
        booking_managerday: '일일 관리',
        booking_management_dashboard: '예약 관리 대시보드',
        table_management: '테이블 관리',
        table_allocation_report: '테이블 할당 보고서',
        table_management_dashboard: '테이블 관리 대시보드',
        liveShop: '라이브 커머스',
        icon_library: '아이콘 라이브러리',
        stores: '상점',
        segments: '세그먼트',
        payment: '결제',
        serviceCategory: '서비스 카테고리',
        SDS: 'KDS',
        sds_manage: '내 KDS',
        sds_layout: '개인화',
        sds_link: '구성',
        sds_display: '디스플레이',
        /* 집계기 */
        config: '구성',
        config_account: '계정 데이터',
        config_sector: '운영 섹터',
        config_user: '사용자',
        config_term: '약관',
        subCategory: '하위 카테고리',
        footer: '바닥글 리소스',
        footerFeature: '리소스 활성화',
        footerContent: '리소스 피드',
        footerContentAddEdit: '리소스',
        webapp: '개인화',
        webapp_qrcode: 'QR 코드 생성',
        ia_menu: '인공 지능',
        ia_config: '구성',
        ia_fit: '교육',
        ia_file_manager: '파일 관리자',
        ia_folders: '폴더',
        ia_files: '파일',
        ia_settings: '설정',
        ia_folders_blank: '폴더가 없습니다',
        ia_filter: '필터',
        ia_recharge: '재충전',
        ia_final_date: '종료일',
        ia_initial_date: '시작일',
        summarize: '대시보드',
        consumption: 'AI 소비',
        ct_account: '소비 및 가치',
        ct_s3_account: 'S3 계정',
        ct_data_cost_account: '데이터 및 비용',
        publication_highlight_banner: '하이라이트 배너',
        publication: '홍보',
        cost: '비용',
        security_settings: '보안 설정',
        coupon: '쿠폰',
        clean_safe: '청결 및 안전',
        service_requests: '서비스 양식',
        grid_hotel: '서비스 그리드',
        /* 호텔 */
        hotel_maintenance: '유지 보수',
        hotel_room: '객실',
        hotel_reservation: '객실 예약',
        hotel_activities_experiences: '활동 및 체험',
        hotel_activities: '활동',
        hotel_tour: '호텔 여행',
        hotel_tour_schedules: '호텔 여행 일정',
        hotel_tour_reservation: '일반 예약',
        hotel_experiences: '체험',
        hotel_info: '정보',
        hotel_reservations: '예약',
        hotel_schedules: '호텔 프로그램',
        publication_banner: '배너',
        feed_back: '피드백 및 만족도',
        feed_back_results: '결과',
        feed_back_analytics: '설문 분석',
        feed_back_content: '피드백 양식',
        feedback_satisfaction: '설문 및 만족도',
        grid_hotel_feedback: '평가',
        feedback_list: '양식',
        feedback: '피드백',
        feed_back_category: '피드백 카테고리',
        post: '게시물',
        post_category: '게시물 카테고리',
        post_content: '게시물 내용',
        booking_hotel: '예약 관리',
        grid_hotel_booking: '서비스 그리드',
        booking_config_hotel: '서비스 예약',
        page_publications: '페이지의 게시물',
        communication: '커뮤니케이션',
        communicationCenter: '커뮤니케이션 센터',
        hotel_management: '호텔 관리',
        hotel_management_entertainment: '엔터테인먼트',
        product_color_variations: '색상 변형',
        feedback_analytics: '설문 분석',
        cashback: '캐시백',
        cashback_list: '내역',
        cashback_config: '설정',
        cashback_management: '관리 및 규칙',
        cashback_report: '리포트',
        hotel_points: '호텔 포인트',
        hotel_points_list: '내역',
        hotel_points_config: '설정',
        hotel_points_management: '관리 및 규칙',
        hotel_points_rewards: '리워드',
        hotel_points_redemptions: '사용 내역',
        hotel_points_report: '리포트',
        pages_dinamic: '동적 페이지',
      },
      // Translations for Color Variations Workbench
      workbench: {
        page_title: '색상 변형',
        page_subtitle: '제품 색상 변형 관리',
        breadcrumb_dashboard: '대시보드',
        breadcrumb_workbench: '색상 워크벤치',

        // Mode Selection
        select_mode: '모드 선택',
        choose_mode: '제품 또는 변형으로 작업하도록 선택',
        mode_product: '제품',
        mode_product_description: '스토어에 등록된 제품 중에서 선택',
        mode_variation: '변형',
        mode_variation_description: '등록된 변형 중에서 선택',

        // Product/Variation Selection
        select_product: '제품 선택',
        select_variation: '변형 선택',
        no_products_found: '제품을 찾을 수 없음',
        no_variations_found: '변형을 찾을 수 없음',
        back_button: '뒤로',
        noImagesFound: '이 제품/변형에 대한 이미지를 찾을 수 없습니다',
        description: '맞춤 색상 변형을 만들기 시작하려면 제품 또는 변형을 선택하세요.',

        // Image and Color Selection
        select_image: '이미지 선택',
        select_color: '색상 선택',
        color_description: '설명 (선택 사항)',
        description_placeholder: '적용할 변경 사항을 설명하세요...',
        select_image_first: '먼저 이미지를 선택하세요',
        processing_error: '변형 처리 중 오류 발생',

        // Buttons
        generate_variation: '변형 생성',
        processing: '처리 중...',
        processing_time_seconds: '{time}초',

        // Preview
        selected_image_preview: '선택된 이미지 미리 보기',
        result_preview: '결과 미리 보기',
        original_image: '원본 이미지',
        processed_image: '처리된 이미지',
        target_color: '대상 색상',
        processing_time: '처리 시간',

        // Actions
        approve_and_apply: '승인 및 적용',
        reject: '거부',
        apply_variation: '변형 적용',
        apply_target: '이 변형을 어디에 적용하시겠습니까?',

        // Apply Dialog
        create_new_variation: '새 변형 만들기',
        new_variation_info: '이 이미지로 새 변형이 만들어집니다',
        replace_existing_variation: '기존 변형 바꾸기',
        select_variation_to_replace: '바꿀 변형을 선택하세요',
        replace_product_image: '제품 이미지 바꾸기',
        select_product_to_replace_image: '바뀔 제품 이미지를 선택하세요',

        // Messages
        variation_saved_success: '변형이 성공적으로 저장되었습니다!',
        error_saving_variation: '변형 저장 중 오류 발생',
        success_title: '성공',
        error_title: '오류',
        warning_title: '경고',

        // Dialog Buttons
        cancel: '취소',
        save: '저장',
        confirm: '확인',
        close: '닫기',
      },
      customer: {
        select_group: '그룹 선택',
        select: '선택',
        create: '고객 생성',
        create_group: '그룹 생성',
        edit: '고객 보기',
        search_custom: '검색...',
        customer: '고객',
      },

      buttons: {
        create: '생성',
        back: '뒤로',
        previous: '이전',
        register_pluginspace: 'Pluginspace 등록',
        access: '액세스',
        add_modality: '모달리티 추가',
        add_km: 'Km 추가',
        zip_code_list: '우편번호 목록',
        add_zip_code: '우편번호 추가',
        area: '배송 지역',
        list_of_negative_renge_zip_code: '음수 우편번호 목록',
        add_negative_zip_code: '음수 우편번호 추가',
        add_user: '사용자 추가',
        generate_password: '비밀번호 생성',
        generate_sku: 'SKU 생성',
        add_group: '그룹 추가',
        save: '저장',
        add_term: '약관 추가',
        add_integration: '통합 추가',
        filter: '필터',
        search: '검색',
        register_product: '제품 등록',
        choose_files: '파일 선택',
        add_categories: '카테고리 추가',
        add_subcategories: '하위 카테고리 추가',
        add_brand: '브랜드 추가',
        close: '닫기',
        add_grade: '그리드 추가',
        add: '추가',
        add_variation: '변형 추가',
        confirm_grades: '그리드 확인',
        add_catalog: '카탈로그 추가',
        generete_qr_code: 'QR 코드 생성',
        personalize: '개인화',
        settings: '구성',
        add_interval: '간격 추가',
        add_gateway: '게이트웨이 추가',
        overview: '개요',
        view: '보기',
        load_csv: '파일 로드',
        download_csv: '표준 XLSX 다운로드',
        att_page: '페이지 새로 고침',
        export: '내보내기',
        add_service: '서비스 등록',
        add_environment: '환경 추가',
        generate_ia: '제안',
        clear_table_card: '테이블 또는 커맨드 지우기',
        propose_image: '이미지 제안',
        cancel: '취소',
        next: '다음',
      },

      global: {
        success: '성공',
        error: '오류',
        warning: '주의',
        active: '활성',
        inactive: '비활성',
      },

      modals: {
        warning_confirm: '확실합니까?',
        warning_save: '저장',
        warning_close: '닫기',
        text_close: '닫기',
      },

      general: {
        delete_item: '이 항목을 삭제하시겠습니까?',
        delete_product_observation: '이 제품의 변형도 삭제됩니다. 그래도 계속하시겠습니까?',
        delete_classification_observation:
          '이 카테고리를 삭제하면 관련된 모든 제품이 일반으로 이동됩니다. 계속하시겠습니까?',
        delete: '삭제',
        edit: '편집',
        duplicate: '복제',
        attention: '주의',
        actions: '작업',
        select: '선택',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          '여기에 항목과 해당 작업이 나열됩니다',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '아래 정보를 작성하고 생성 버튼을 클릭하여 변경 사항을 저장하십시오',
        save_changes_edit: '아래 정보를 작성하고 저장 버튼을 클릭하여 변경 사항을 확인하십시오',
        save_changes_duplicate:
          '아래 정보를 확인하거나 변경하고 저장 버튼을 클릭하여 변경 사항을 확인하십시오',
        active: '활성',
        inactive: '비활성',
        showing: '표시',
        of: '의',
        to: '까지',
        records: '기록',
        type: '유형',
        today: '오늘',
        copy: '복사',
        linkS3: '링크',
        linkedS3: '연결됨',
        downloadS3: '다운로드',
        downloadedS3: '다운로드 시작됨',
        copied: '복사됨',
        copy_link: '판매자 링크 복사',
        test: '테스트',
        success: '성공',
        error: '오류',
        email: '이메일',
        paymentFree: '무료',
        image_2mb_message: '파일 크기가 2MB를 초과합니다. 더 작은 파일을 선택해주세요.',
      },

      pluginspaces: {
        hospitality: '호텔',
        food: '음식',
        healthcare: '접객',
        varejo: '소매',
        fashion: '패션',
      },

      dashboard: {
        totals_by_products: '제품별 합계',
        totals_by_category: '카테고리별 합계',
        last_orders: '최신 주문',
        products: '제품',
        quantity: '수량',
        total: '합계',
        category: '카테고리',
        welcome: 'Ninegrid에 오신 것을 환영합니다',
        describe_dashboard:
          '여기에는 상점을 간단하고 효율적으로 관리하는 모든 도구가 있습니다. 측면 메뉴를 탐색하여 기능을 탐색하십시오. 좋은 일 하세요!',
      },

      modalities: {
        modalities: '모달리티',
        modalitie: '모달리티',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          '여기에 모달리티와 해당 작업이 나열됩니다',
        delivery: '배송',
        withdraw: '픽업',
        active: '활성',
        inactive: '비활성',
        name: '이름',
        code: '코드',
        actions: '작업',
        search: '검색',
        type: '유형',
        sector_name: '섹터 이름',
        table: '테이블',
        room: '객실',
        counter: '카운터',
        internal: '내부 배송',
        synkar: 'Synkar',
      },

      delivery_fee: {
        delivery_fee: '배송 수수료',
        create_delivery_fee: '배송 수수료 생성',
        edit_delivery_fee: '배송 수수료 편집',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '아래 정보를 작성하고 생성 버튼을 클릭하여 변경 사항을 저장하십시오',
        save_changes_edit: '아래 정보를 작성하고 저장 버튼을 클릭하여 변경 사항을 확인하십시오',
        km_min: '최소 Km',
        km_max: '최대 Km',
        value: '가격',
        actions: '작업',
        patterns: '가져오기 패턴',
        import_file: '파일을 가져오려면 파일의 첫 번째 셀이 다음 패턴 중 하나를 따라야 합니다:',
        import_delivery: '범위별 가져오기: kmmin, kmmax, Value',
        import_cep: '우편번호별 가져오기: cep_inicio, cep_fim, 값',
        import_cep_negative: '음수 우편번호별 가져오기: cep_inicio, cep_fim',
        model: '모델',
        continue_import: '모든 기록이 대체됩니다. 계속하시겠습니까?',
        cep_delivery: '배송 우편번호',
        cep_info: '여기에 배송 우편번호와 해당 작업이 나열됩니다.',
        cep_start: '우편번호 시작',
        cep_end: '우편번호 끝',
        create_cep: '배송 우편번호 생성',
        edit_cep: '배송 우편번호 편집',
        cep_delivery_negative: '음수 배송 우편번호',
        cep_info_negative: '여기에 음수 배송 우편번호와 해당 작업이 나열됩니다.',
        create_cep_negative: '음수 우편번호 생성',
        edit_cep_negative: '음수 우편번호 편집',
        delete_cep_negative: '음수 우편번호 삭제',
      },

      user: {
        user: '사용자',
        here_are_listed_the_users_along_with_their_respective_actions:
          '여기에 사용자와 해당 작업이 나열됩니다',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '아래 정보를 작성하고 생성 버튼을 클릭하여 변경 사항을 저장하십시오',
        save_changes_edit: '아래 정보를 작성하고 저장 버튼을 클릭하여 변경 사항을 확인하십시오',
        picture: '사진',
        name: '이름',
        type: '유형',
        registration: '등록',
        create_user: '사용자 생성',
        edit_user: '사용자 편집',
        profile_picture: '프로필 사진',
        password: '비밀번호',
        generate_pass: '비밀번호 생성',
        access_level: '액세스 그룹',
        select_a_access_level: '액세스 그룹 선택',
        select_type: '유형 선택',
        active: '활성',
        actions: '작업',
        discount_permission: '판매 할인 권한',
        discount_value: '최대 할인 금액 (%)',
        phone: '전화 번호',
      },

      groups: {
        groups: '그룹',
        group: '그룹',
        here_are_listed_the_groups_along_with_their_respective_actions:
          '여기에 그룹과 해당 작업이 나열됩니다',
        name: '이름',
        Integrations: '통합',
        means_of_payment: '결제 수단',
        products: '제품',
        category: '카테고리',
        subcategory: '하위 카테고리',
        indicators: '지표',
        requests: '주문',
        reports: '보고서',
        messenger: '메시징',
      },

      shifts: {
        shifts: '교대 근무',
        here_are_listed_the_shifts_for_each_day_of_the_week:
          '여기에 주중 각 요일에 대한 교대 근무가 나열됩니다',
        monday: '월요일',
        tuesday: '화요일',
        wednesday: '수요일',
        thursday: '목요일',
        friday: '금요일',
        saturday: '토요일',
        sunday: '일요일',
        start: '시작',
        end: '종료',
      },

      account: {
        account: '계정',
        edit_account: '계정 편집',
        registration_number: 'CNPJ',
        corporate_name: '법인명',
        customer_name: '이름',
        name_of_the_establishment: '시설 이름',
        subdomain: '하위 도메인',
        code: '코드',
        default_language: '기본 언어',
        default_currency: '기본 통화',
        login_of_person_in_charge: '계정 담당자 로그인',
        name_of_person_in_charge: '담당자 이름',
        address: '주소',
        zip_code: '우편번호',
        number: '번호',
        neighbourhood: '이웃',
        city: '도시',
        state: '주',
        public_place: '도로명',
        address_complement: '추가',
        info: '하위 도메인을 변경하려면 지원팀에 문의하십시오',
      },

      terms: {
        terms: '약관',
        here_are_the_terms_of_acceptance_of_the_sales_platform:
          '여기에 판매 플랫폼의 동의 약관이 나열됩니다',
        create_your_term: '약관 생성',
        term_name: '약관 이름',
        valid_until: '유효 기간',
        name: '이름',
        expirated: '만료됨',
      },

      payment_plans: {
        payment_plans: '결제 계획',
        here_are_listed_the_payment_plans_along_with_their_respective_actions:
          '여기에 결제 계획과 해당 작업이 나열됩니다',
        create_payment_plans: '결제 계획 생성',
        fill_the_information_below_and_click_the_create_button_to_save_the_changes:
          '아래 정보를 작성하고 생성 버튼을 클릭하여 변경 사항을 저장하십시오',
        erp_integration: 'ERP 통합',
        integration_type: '통합 유형',
        select_an_integration: '통합 선택',
        card_flag: '카드 브랜드',
        flag: '브랜드',
        type: '유형',
        erp_code: 'ERP 코드',
        card_installment: '할부',
        payment_plan: '결제 계획',
        installment: '할부',
        time: '기간',
        credit: '신용',
        debit: '직불',
      },

      indicators: {
        indicators: '지표',
        orders: '주문',
        filters: '필터',
        first: '시작',
        end: '종료',
        total_order: '총 주문 수',
        revenue: '수익',
        orders_by_location: '모달리티별 주문',
        orders_by_month: '월별 주문',
        orders_by_day: '일별 주문',
        orders_by_hour: '시간별 주문',
        orders_by_month_sector: '월 및 모달리티별 주문',
        orders_by_day_sector: '일 및 모달리티별 주문',
        orders_by_hour_sector: '시간 및 모달리티별 주문',
        product: '제품',
        categories: '카테고리',
        sales_by_category: '카테고리별 판매',
        revenue_by_category: '카테고리별 수익',
        average_ticket: '평균 객단가',
        quantity: '수량',
        summary: '요약',
        summaryAccess: '액세스',
        summaryAccessGroup: '기간별 액세스된 영역',
        summaryTimeAccessGroup: '시간별 합계',
        summaryIPAccessGroup: '사용자별 합계',
        summarySellerCart: '판매자별 생성된 장바구니 합계',
        period: '기간 선택',
        summaryTypeCust: '비용 유형별 합계',
        summaryComposition: '비용 구성',
        cost: '비용',
        customer: '고객',
        seller_sales_by_category: '판매자별 카테고리 판매',
        summary_seller: '판매자 요약',
        sellers_invoice: '판매자 청구서 발행',
        comparative_sales_by_channel: '채널별 판매 비교',
        select_view: '보기 선택',
        sales: '판매',
        attended_customers: '서비스를 받은 고객',
        carts: '저장된 장바구니',
        sales_conversion: '판매 전환',
        mean_ticket: '평균 객단가',
        sales_client: '고객별 판매 비교/순위',
        sellers: '판매자',
        summary_store: '상점 요약',
        accesses: '방문',
        active_sellers: '활성 판매자',
        revenue_store: '상점 청구서 발행',
        revenue_group: '그룹 청구서 발행',
        comparative_sales_by_seller: '판매자별 판매 비교',
        comparative_sales_by_store: '사업 단위 비교',
        comparative_by_seller: '판매 능력 - 판매자 비교',
        stores: '상점',
        invoicing: '청구서 발행',
        active_stores: '활성 상점',
        summary_group: '그룹 요약',
        invoice_by_store: '상점별 청구서 발행',
        rank_sellers: '판매자 순위',
        rank_stores: '상점 순위',
      },

      customer_list: {
        customer_list: '고객 목록',
        listed_customers: '여기에 고객과 해당 작업이 나열됩니다.',
        select_time: '이루어진 주문 기간',
        name: '이름',
        first: '시작',
        end: '종료',
        phone: '전화',
        date: '날짜',
        detail: '고객 세부 정보',
        total_profit: '총 이익',
        total_itens: '총 항목 수',
        total_orders: '총 주문 수',
        order_between: '사이의 주문',
        order_detail: '주문 세부 정보',
        create: '고객 생성',
        go_detail: '세부 정보 보기',
        product: '제품',
        value: '가격',
        quantity: '수량',
        total: '합계',
        edit: '고객 편집',
      },

      smart_order: {
        smart_order: '스마트 오더',
        service_classification: '서비스 분류',
        message_warning_find_variation: '변형을 찾지 못했습니다. SKU/EAN을 확인하십시오.',
        product: '제품',
        create_product: '제품 생성',
        here_are_listed_the_products_along_with_their_respective_actions:
          '여기에 제품과 해당 작업이 나열됩니다',
        name: '이름',
        code: '코드',
        color_code: '색상 코드',
        crop_image: '이미지 자르기',
        use_original_image: '원본 이미지 사용',
        select_image_format: '이미지 형식 선택',
        use_selected_size: '선택한 크기 사용',
        format_640x640: '640x640 (정사각형)',
        format_600x900: '600x900 (세로)',
        product_data: '제품 데이터',
        mark: '브랜드',
        measurement_unit: '측정 단위',
        description: '설명',
        technical_specification: '기술 사양',
        from: '의',
        characters: '문자',
        order: '순서',
        product_image: '제품 이미지',
        additional_images: '추가 이미지',
        product_groups: '제품의 고객 그룹',
        categories: '카테고리',
        here_are_listed_the_categories_along_with_their_respective_actions:
          '여기에 카테고리와 해당 작업이 나열됩니다',
        image: '제품 이미지',
        image_variation: '변형 이미지',
        category: '카테고리',
        category_parent: '부모 카테고리',
        category_name: '카테고리 이름',
        category_code: '카테고리 코드',
        perfil_image: '프로필 이미지',

        subcategories: '하위 카테고리',
        subcategory: '하위 카테고리',
        here_are_listed_the_subcategories_along_with_their_respective_actionsc:
          '여기에 하위 카테고리와 해당 작업이 나열됩니다',
        select_category: '카테고리 선택',

        marks: '브랜드',
        listened_marks: '여기에 브랜드와 해당 작업이 나열됩니다',

        measurements_units: '측정 단위',
        listened_measurement: '여기에 측정 단위와 해당 작업이 나열됩니다',

        grid_products: '그리드',
        listened_grid: '여기에 제품 그리드와 해당 작업이 나열됩니다',
        grid_name: '그리드 이름',
        grid_code: '코드',
        variation: '변형',
        grid: '그리드',
        grids: '그리드',

        variations: '변형',
        listened_variations: '여기에 제품 변형과 해당 작업이 나열됩니다',
        modality: '모달리티',
        select_modality: '모달리티 선택',
        prod: '제품',
        select_product: '제품 선택',
        no_variation: '변형 없는 제품',
        variation_product: '제품 변형',
        cost_price: '원가',
        sell_price: '판매 가격',
        promotional_price: '프로모션 가격',
        weight: '무게',
        height: '높이',
        width: '너비',
        depth: '깊이',
        availability: '제품의 가용성은 어떻습니까?',
        when_product_stock: '제품 재고가 소진되면 어떻게 됩니까?',
        stock: '재고 제품 수량',
        min_stock: '최소 재고',
        price: '가격',

        catalogs: '카탈로그',
        catalog: '카탈로그',
        create_catalog: '카탈로그 생성',
        edit_catalog: '카탈로그 편집',
        catalog_link: '카탈로그 링크 복사',
        listened_catalogs: '여기에 제품 카탈로그와 해당 작업이 나열됩니다.',
        validity: '유효 기간',
        first: '시작',
        end: '종료',
        search_products: '제품 검색',

        product_status: '제품 상태',
        sku: 'SKU/EAN',
        status_variation: '변형 상태',
        specification: '사양',
        price_promotional: '할인 가격',
        inventory: '재고',
        preparation_time: '준비 시간',
        service_title: '여기에 서비스와 해당 작업이 나열됩니다.',

        initial_hour: '시작 시간',
        final_hour: '종료 시간',

        date_start: '시작일',
        date_end: '종료일',

        add_group: '추가 항목 목록',
        no_add: '이 제품은 아직 추가 항목 목록과 연결되어 있지 않습니다.',
        already_add: '이 제품은 다음 추가 항목 목록과 연결되어 있습니다.',
        associate_add: '추가 항목 목록과 연결',
        associate: '연결',
        choose_add: '이 제품과 연결할 추가 항목 목록을 선택하십시오.',
        no_group_add: '연결할 수 있는 추가 항목 목록이 없습니다.',
        remove_add: '연결 제거',
        remove_add_text: '이 제품과 추가 항목 목록 "@"의 연결을 제거하시겠습니까?',
        limit_range: '최대 간격 제한에 도달했습니다',

        remove_add_soon:
          '주의! 이 탭은 곧 제거됩니다. 계속해서 추가 항목을 정상적으로 관리할 수 있습니다. "기본 정보" 탭에 액세스하여 "추가 항목 그룹" 세션으로 이동하여 이 제품의 추가 항목을 확인하십시오.',
        create_image_ia: 'AI 이미지 제안',
        create_image_ia_text: '이미지를 생성할 제품 설명을 제공하십시오.',
        generate_images: '이미지 생성',
        generate_description: '설명 개인화',
        generate_new_options: '새 옵션 생성',
        save_image_selected: '선택한 사진 저장',
        reference_image_ia: '참조 이미지',
        image_qtd_ia: '이미지 수량',
        save_img_ia: '이미지 저장',
        cancel: '취소',

        more_category: '이 카테고리의 더 많은 구성 보기',
        selectAll: '모두 선택',
        alterLot: '배치 변경',
        edit_category: '카테고리 연결 변경은 허용되지 않습니다. 새 카테고리를 만드는 것이 좋습니다',

        catalog_image: '카탈로그 이미지',
      },

      service_grid: {
        service_grid: '서비스 그리드',
        service_grid_single: '서비스 그리드',
        create_service_grid: '서비스 그리드 생성',
        edit_service_grid: '서비스 그리드 편집',
        service_grid_name: '서비스 그리드 이름',
        service_grid_name_placeholder: '서비스 그리드 이름',
        start_hour: '시작 시간',
        start_hour_placeholder: '00:00',
        end_hour: '종료 시간',
        end_hour_placeholder: '23:59',
        interval: '간격',
        interval_placeholder: '00:15',
        interval_tooltip: '주문 간의 시간 간격',
        service_list: '서비스 목록',
        service_placeholder: '서비스',
        missing_fields: '누락된 필드',
        missing_fields_message: '모든 필드를 작성했는지 확인하십시오!',
        grid_created: '그리드 등록됨',
        grid_created_message: '등록 성공!',
        grid_updated: '그리드 변경됨',
        grid_updated_message: '편집 성공!',
        error: '오류',
        error_create_message: '그리드 등록 중 오류 발생!',
        error_update_message: '그리드 변경 중 오류 발생!',
        fill_information_create:
          '아래 정보를 작성하고 생성 버튼을 클릭하여 변경 사항을 저장하십시오',
        save_changes_edit: '아래 정보를 작성하고 저장 버튼을 클릭하여 변경 사항을 확인하십시오',
        dashboard: '대시보드',
        title: '제목',
        listed_grids: '여기에 서비스 그리드와 해당 작업이 나열됩니다',
        grid_deleted: '그리드 삭제됨',
        grid_deleted_message: '삭제 성공!',
        error_delete_message: '그리드 삭제 중 오류 발생!',
        status: '상태',
        grid_linked_warning: '그리드 연결됨',
        grid_linked_message:
          '이 그리드는 {count}개의 서비스 양식과 연결되어 있어 삭제할 수 없습니다.',
      },

      webapp: {
        webapp: '웹 앱',
        generate_qrcode: 'QR 코드 생성',
        personalize: '개인화',
        settings: '구성',
        link: '웹 앱 링크',

        webapp_data: '웹 앱 데이터',
        name: '이름',
        place: '장소',
        product_pagination: '페이지 매김의 제품 수량',
        logo_ninegrid: 'Ninegrid 로고',
        light: '밝음',
        dark: '어두움',
        logo_totvs: 'TOTVS 로고',
        use_icon_menu: '웹 앱 메뉴에서 아이콘 사용',
        description: '설명',
        icon: '아이콘',
        color_setting: '색상 구성',
        background_webapp: '웹 앱 배경',
        background_default_webapp: '웹 앱 기본 색상',
        background_header: '헤더 배경',
        text_header: '헤더 텍스트',
        icon_header: '헤더 아이콘',
        background_footer: '바닥글 배경',
        icon_footer: '바닥글 아이콘',
        highlight_footer: '바닥글 강조',
        notification_cart: '장바구니 알림',
        notification_text: '알림 텍스트',
        home_button: '홈 버튼',
        text_home_button: '홈 버튼 텍스트',
        title_bar: '제목 표시줄',
        text_title_bar: '제목 표시줄 텍스트',
        icon_title_bar: '제목 표시줄 아이콘',
        text_category: '카테고리 텍스트',
        webapp_button: '웹 앱 테마',
        text_button: '버튼 텍스트',
        background_menu: '측면 메뉴 배경',
        text_menu: '측면 메뉴 텍스트',
        price_card_background: '가격 카드 배경',
        price_card_font_color: '가격 카드 글꼴 색상',
        order_status: '주문 상태',
        order_active_status: '활성 주문 상태',
        text_order_active_status: '주문 상태 텍스트',
        info_cart: '장바구니 정보',

        settings_webapp: '웹 앱 설정',
        type_delivery: '배송 제한 유형',
        integration: '통합',
        select_integration: '통합 선택',
        payment_method_card: '결제 수단 카드',
        payment_method_pix: '결제 수단 Pix',
        payment_method_delivery: '결제 수단 배송 시',
        consent_letter: '동의서 활성화',
        product_no_stock: '재고 없는 제품 판매',
        show_subcategory: '하위 카테고리 표시',
        show_observation: '비고 표시',
        use_category_list: '하위 카테고리 및 제품을 목록으로 표시',
        use_category_list_v2: '카테고리 및 하위 카테고리를 목록으로 표시',
        use_product_list: '제품을 목록으로 표시',
        remove_shadow: '카테고리 및 카탈로그에 그림자 추가 안 함',
        remove_show_mode: '표시 모드 제거',
        no_shadow: '카테고리에 그림자 추가 안 함',
        is_order_number: '카테고리 정렬',
        order_number: '순서대로',
        order_category: '알파벳순',
        show_layout: '레이아웃 표시',
        image_type: '제품 이미지 스타일',

        withdraw_fee: '픽업 수수료',
        minimum_value: '최소 주문 금액',
        seller_checkout: '결제 모달리티',

        no_sales: '판매 허용 안 함',
        safe_mode: '안전 모드',
        time_safe_mode: '안전 모드 세션 시간 (분)',
        limit_characteres_explanation:
          'Wintor 또는 Protheus 통합이 있는 상점의 경우 최대 50자가 권장됩니다.',
        limit_characteres: '문자 제한',

        skip_entry: '진입 화면 건너뛰기',
        payment_table: '테이블에서 결제',

        payment_card: '커맨드에서 결제',

        slides_homePage: '홈페이지 하이라이트 이미지',
        slides_initial: '초기 하이라이트 이미지',

        slides_not_found: '슬라이더 이미지를 찾을 수 없습니다',

        externalLink: '외부 링크',
        buttonType: '버튼 유형',
        ableUserLocation: '위치별 주소 검색 허용',
        ableWaiter: '웨이터 호출 옵션 비활성화',
        closeAccountButton: '계정 폐쇄 버튼 제거',
        emitNfChef: '주문 결제 후 송장을 발행하시겠습니까? (카운터/테이블/커맨드)',

        seller_cart_limit_time: '판매자 장바구니 시간당 만료 시간',
        seller_cart_limit_time_explanation: '고객이 판매자 장바구니를 사용할 수 있는 최대 시간',
        settings_webapp_aggregator: '개인화',
        generate_qrcode_webapp_aggregator: 'QR 코드 생성',
        qrcode_webapp_aggregator: '웹 애플리케이션',
        security_settings: '보안 설정',
        biometric_authentication: '생체 인증',
        code_scanner: '바코드 및 QR 코드 판독기 허용',
        maximus_radius: '위치: 허용되는 최대 근접 반경 (미터)',
        access_maximus: '테이블당 최대 액세스 수',
        limit_time: '커맨드가 만료될 때까지의 액세스 시간 (분)',
        password: '액세스 해제 비밀번호',
        flag_discount: '할인 플래그 형식',
        color_flag_discount: '태그 색상',

        config_tags: '태그 구성',
        promotional_tags: '프로모션 태그',

        pre_created: '사전 등록',

        show_classification_button: '모든 카테고리 보기 버튼 표시',
        show_catalog_button: '모든 카탈로그 보기 버튼 표시',
        show_catalog_name: '카탈로그 이름 표시',
        can_acesse_restaurant: '로그인 없이 카탈로그(매장/레스토랑) 보기 허용',
        info_acesse_restaurant:
          '이 플래그를 활성화하면 사용자가 로그인 없이 레스토랑 또는 매장 메뉴/카탈로그에 액세스할 수 있습니다. 활성 결제 통합이 있는 경우, 주문이 호텔 시스템의 사용자 컨텍스트(프로필/예약)에 올바르게 연결되도록 결제 단계 전에 매장 또는 레스토랑 WebApp에서 직접 로그인이 요청됩니다.',
        show_classification_name: '카테고리 이름 표시',
        show_mark_name: '제품 브랜드 표시',
        show_stock_quantity: '제품 재고 표시',
        show_promotional_tags: '프로모션 라벨 표시',
        show_product_sku: '제품 SKU 표시',
        tag_display_groups: '제품 목록에 태그 그룹 표시',
        text_free_delivery: '무료 배송 또는 픽업을 위한 사용자 지정 텍스트',
        tooltip_free_delivery:
          '작성된 경우 배송 또는 픽업이 무료일 때 이 텍스트가 표시됩니다. 비어 있으면 R$ 0,00 값이 표시됩니다',
        place_holder_free_delivery: '예: 무료',
        no_show_grid: '제품 단일 변형의 그리드 생략',
        explain_show_grid:
          '단일 변형이 있는 그리드를 숨깁니다. 여러 옵션이 있는 그리드(예: 크기 G, GG)는 제품 선택에서는 표시되지만 다른 위치에서는 숨겨집니다.',

        type_image: '이미지 유형',
        type_image_square: '정사각형',
        type_image_rectangle: '직사각형',

        directlink: '직접 링크',
        infoDirectLink:
          '필수 사항은 아니며 다른 페이지나 사이트로 직접 보내야 하는 경우에만 사용하며 최대 350자입니다',

        block_add_in_limit: '제한에서 추가 차단',

        family_fonte: '글꼴 패밀리',
        rounding_images: '이미지 모서리 둥글게',
        rounding_bars: '바 모서리 둥글게',
        color_icons: '아이콘 색상',
        color_icons_header_footer: '헤더 및 푸터의 아이콘 색상',
        background_icon_button: '아이콘 배경 색상',
        background_icon_custom: '사용자 지정 색상',
      },

      integration: {
        integration: '통합',
        means_of_payment: '결제 수단',
        here_are_listed_the_means_of_payment_along_with_their_respective_actions:
          '여기에 결제 수단과 해당 작업이 나열됩니다',
        PDV: 'POS 통합',
        listed_here_are_the_integrations_along_with_their_respective_actions:
          '여기에 통합과 해당 작업이 나열됩니다',
        integration_name: '통합 이름',
        type_of_integration: '통합 유형',
        actions: '작업',
        search: '검색',
        example: 'Payload 예제',

        loads: '로드',
        name: '이름',
        price: '가격',
        stock: '재고',
        measurements_units: '측정 단위',
        grid: '그리드',
        classifications: '카테고리',
        products: '제품',
        status_sync: '상태 동기화',
        marks: '브랜드',
        orders: '주문',
        trigger_load: '로드 트리거',
        first: '시작',
        end: '종료',
        load: '로드',
        messenger: '메시징',
        others: '기타',
        test: '통합을 테스트하시겠습니까',
        params_test: '이 통합 매개변수 보기',
        copy_params: '매개변수 복사',
        result_test: '통합 테스트 결과',
        success_1: '성공! 통합',
        success_2: '성공했습니다.',
        result_log: '결과 로그',
        copy_result: '결과 복사',
        search_result: '결과 검색',
        error_1: '통합',
        error_2: '오류를 반환했습니다. 자세한 내용은 아래 로그를 확인하십시오.',

        success_food_1: '성공! 통합',
        success_food_2: '성공했습니다.',
        error_food_1: '통합',
        error_food_2: '오프라인을 반환했습니다.',

        integrationPrint: '연결 테스트',
      },

      reports: {
        orders: '주문',
        order_report: '주문 보고서',
        order_list: '주문 목록',
        first: '시작',
        end: '종료',
        firstTime: '시작 시간',
        endTime: '종료 시간',
        orders_between: '사이의 주문',
        order_number: '주문 번호',
        date: '날짜',
        consumer: '소비자',
        modality: '모달리티',
        total_value: '가격',
        cancel_order: '주문 취소',

        products: '제품',
        quantity: '수량',
        qtt: '수량',
        product: '제품',
        value: '가격',
        total: '합계',
        order_status: '주문 상태',
        payment_method: '결제 수단',
        billing_address: '청구 주소',
        product_value: '제품 가격',
        discount: '할인',
        order: '주문',

        listened_logs: '여기에 로그와 해당 작업이 나열됩니다.',
        methods: '메서드',
        log_details: '로그 세부 정보',

        withdraw: '픽업',
        delivery: '배송',
        table: '테이블',
        counter: '카운터',
        responsible_withdraw: '픽업 담당자',
        responsible_delivery: '접수 담당자',
        address_withdraw: '픽업 주소',
        address_delivery: '배송 주소',
        seller: '판매자',
        seller_link: '판매자 링크',
        external_code: '외부 번호',
        payment: '결제',
        internal_delivery: '내부 배송',
        origin: '출처',
        historial: '주문 내역',
        approval_moment: '승인 날짜 및 시간',
        id: '예약 코드',
        pluginspace: '호텔',
        hotel: '호텔과 연결된 주문',
        document: '예약 문서',
        room: '객실 코드',
        status_payment: '결제 상태',
        authorization_code: '승인 코드',
        transaction: '거래 ID',
        made_in: '수행일',
        send_method: '발송 방법',
        send_date: '발송일',
        estimated_delivery: '예상 배송',
        freight: '운임',
        tracking_code: '추적 코드',
        website: '추적 웹사이트 열기',
        label: '배송 라벨 인쇄',
        payment_delivery: '배송 시 결제',
        payment_money: '현금 결제',
        change_money: '거스름돈',
        label_code: '라벨',
        label_website: '라벨 웹사이트 열기',
        declaration_code: '선언',
        declaration_website: '선언 웹사이트 열기',
        height: '높이 (cm)',
        width: '너비 (cm)',
        length: '길이 (cm)',
        weight: '무게 (kg)',
        send_text: '고객이 선택한 발송 방법:',
        success_label: '배송 라벨이 성공적으로 생성되었습니다.',
        continue: '계속',
        confirm: '확인',
        change_multiple_status: '여러 주문의 상태 변경',
        change_status_text: '아래 주문의 상태를 변경하시겠습니까?',
        new_status: '새 상태',
        change_status: '상태 변경',

        synkar: '자동화',
        invalid_data: '시작 및 종료 날짜를 선택하십시오.',
        robot_attention_title: '주의',
        robot_error_title: '오류',
        robot_success_title: '성공!',
        robot_delivery_title: '로봇 배송',
        robot_delivery_description: '배송을 보내려면 로봇과 목적지 지점을 선택하세요.',
        robot_label: '로봇',
        robot_fallback_name: '로봇 #{{id}}',
        robot_no_data: '이 로봇에 대해 반환된 데이터가 없습니다.',
        robot_map: '지도',
        robot_map_alt: '로봇 지도',
        robot_delivery_points: '배송 지점',
        robot_no_points: '등록된 지점이 없습니다.',
        robot_send: '로봇으로 보내기',
        robot_load_points_error: '로봇 지점을 불러올 수 없습니다.',
        robot_fetch_points_error: '로봇 지점을 조회하는 중 오류가 발생했습니다.',
        robot_send_unavailable: '이 주문을 로봇으로 보낼 수 없습니다.',
        robot_select: '로봇을 선택하세요.',
        robot_select_point: '배송 지점을 선택하세요.',
        robot_send_success: '주문이 로봇으로 성공적으로 전송되었습니다!',
        robot_send_error: '주문을 로봇으로 전송하는 중 오류가 발생했습니다.',

        details: '세부 정보',
      },

      imports: {
        imports: '가져오기',
        import_image_product: '제품 이미지 가져오기',
        import_image_category: '카테고리 이미지 가져오기',
        listened_import_product: '여기에 제품 이미지 가져오기와 해당 작업이 나열됩니다.',
        no_upload_images: '이미지 업로드 안 함',
        first: '시작',
        end: '종료',
        total_products: '총 제품 수',
        sync_products: '동기화된 제품',
        import_image_sku: '변형 이미지 가져오기',
        listened_import_sku: '여기에 변형 이미지 가져오기와 해당 작업이 나열됩니다.',
        verify_verification: '변형 확인',
        product_code: '제품 코드',
        code: '코드',
        total_variations: '총 변형 수',
        sync_variations: '동기화된 변형',
        total_categories: '총 카테고리 수',
        sync_categories: '동기화된 카테고리',
        problem_title: '문제가 있는 이미지',
        images_success: '이미지가 성공적으로 전송되었습니다.',
        images_error: '이미지에 문제가 발생하여 전송되지 않았습니다.',
        file: '파일',
        status: '가져오기 상태',
        new_import: '새 가져오기 수행',
        import_xls: 'XLS 파일로 이미지 가져오기',
        import_repo: 'Google Drive 또는 Dropbox에서 이미지 가져오기',
        steps: '가져오기 단계별 안내',
        step_1: '1. 모든 이미지를 공개 웹 서버에 배치합니다.',
        step_2: '2. 서버가 공개되어 있고 웹을 통해 액세스할 수 있는지 확인합니다.',
        step_3: '3. 빈 XLSX 파일을 다운로드합니다.',
        step_4: '4. 이미지 뱅크 데이터로 채웁니다.',
        step_5: '5. 채워진 파일을 업로드합니다.',
        step_1_repo: '1. 상점 폴더가 "fotos_loja_<상점 식별자>"로 생성되었는지 확인합니다.',
        step_2_repo: '2. 상점 폴더 안에 "produtos" 폴더를 생성합니다.',
        step_2_repo_sku: '2. 상점 폴더 안에 "variacoes" 폴더를 생성합니다.',
        step_2_repo_category: '2. 상점 폴더 안에 "categorias" 폴더를 생성합니다.',
        step_3_repo: '3. 파일이 "<제품 코드>.<확장자>" 형식인지 확인합니다.',
        step_3_repo_sku: '3. 파일이 "<sku>.<확장자>" 형식인지 확인합니다.',
        step_3_repo_category: '3. 파일이 "<카테고리 코드>.<확장자>" 형식인지 확인합니다.',
        step_4_repo: '4. 추가 제품인 경우 "_<번호>"가 있는지 확인합니다.',
        step_4_repo_sku: '4. 변형이 이미지이며 JPG 또는 PNG 확장자인지 확인합니다.',
        step_4_repo_category: '4. 카테고리가 이미지이며 JPG 또는 PNG 확장자인지 확인합니다.',
        step_5_repo: '5. 제품이 이미지이며 JPG 또는 PNG 확장자인지 확인합니다.',
        download: '빈 XLSX 파일 다운로드',
        download_problems: '보고서 내보내기',
        upload: '파일 전송',
        upload_anex: '파일 첨부',
        import_dropbox: 'Dropbox로 가져오기',
        import_drive: 'Google Drive로 가져오기',
        spreadsheet: '스프레드시트',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        type: '유형',
        type_resize: '크기 조정 유형',
        agroup_color: '색상별로 사진 그룹화',
        banner_size: 'N1 카테고리를 배너로 처리',
        select_dimensions: '크기 선택',
        square: '640x640으로 처리',
        vertical: '600x900으로 처리',
      },

      sms: {
        sms: 'SMS',
        listened_sms: '여기에 메시지(SMS)와 해당 작업이 나열됩니다.',
        order: '순서',
        name: '이름',
        message: '메시지',
        markers: '[pedido] 및 [status] 마커는 메시지에 있어야 합니다',
        waiting: '대기 중',
        opened: '미결',
        ready: '준비 완료',
        refused: '거부됨',
        message_hotel: '호텔 SMS',
        listened_sms_hotel: '여기에 호텔 메시지와 해당 작업이 나열됩니다.',
        status_hotel: '호텔 상태',
        listened_status_hotel: '여기에 호텔 상태와 메시지 및 해당 작업이 나열됩니다.',
        edit_status: '상태 편집',
        edit_status_hotel: '호텔 상태 편집',
        notification: '알림',
        email_group_status: '상태',
        email_group_service_forms: '서비스 양식',
        email_group_services: '서비스',
        email_group_services_booking: '서비스 - Booking',
        email_group_tours: 'Tours',
        email_group_activities: 'Activities',
        email_group_experiences: 'Experiences',
        send_email_simple: '이메일 보내기',
        status_label: '상태',
        write_message_status: '이 상태에 대한 메시지를 여기에 작성하세요',
        markers_hotel:
          '[pedido], [status], [cliente], [quarto], [hotel] 마커는 메시지에 있어야 합니다',
        status_updated: '상태가 업데이트되었습니다',
        status_update_success: '업데이트가 성공적으로 완료되었습니다!',
        status_update_error_title: '오류',
        status_update_error: '상태를 업데이트하는 중 오류가 발생했습니다!',
      },

      multichannel: {
        multichannel: '다채널',
        listened_multichannel: '여기에 다채널 구성과 해당 작업이 나열됩니다.',
      },

      feed: {
        content: '콘텐츠',
        title: '제목',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          '아래 정보를 작성하고 생성 버튼을 클릭하여 변경 사항을 저장하십시오',
      },
      feedCategory: {
        feedCategory: '콘텐츠 카테고리',
      },

      structured_content: {},

      queue: {
        index: '대기열',
        menage: '관리',
        config: '대기열 구성',
        able: '대기열 허용',
        link: '대기열 링크:',
        limit_people: '최대 인원',
        limit_people_text: '대기열 제한',
        limit_time: '경고를 표시할 시간 제한',
        limit_time_text: '지연으로 간주할 최대 시간(분)',
        image_title: '이미지 정의',
        image_text:
          '대기열 시스템은 2개의 이미지를 표시합니다. 레스토랑 사진을 업로드하거나 아래에서 기본 사진을 선택하십시오. 전송된 사진은 350x250 픽셀 크기로 조정됩니다.',
        image: '이미지',
        position: '위치',
        time: '대기 시간',
        people: '명',
        cancel: '취소',
        cancel_text: '이 사람을 대기열에서 제거하시겠습니까?',
        cancel_button: '제거',
        confirm: '확인',
        confirm_text: '예약자의 도착을 확인하시겠습니까?',
        confirm_button: '도착 확인',
        empty: '현재 대기 목록이 없습니다',
        confirm_all: '모두 확인',
        cancel_all: '모두 취소',
        observation: '비고',
        use_terms: '동의 약관 활성화',
        total_people: '그룹당 총 인원',
        total_people_text: '그룹당 대기열 제한',
        all: '모두',
        in_queue: '대기 중',
        preferential: '우선',
        confirmed: '확인됨',
        removed: '거부됨',
        show: '표시',
        show_text: '지난 @ 시간',
        yes: '예',
        no: '아니오',
        add: '고객을 대기열에 추가',
        use_location: '위치 허용?',
        use_menu: '메뉴를 사용하시겠습니까?',
        use_ninegrid_menu: 'Ninegrid 메뉴를 사용하시겠습니까?',
        external_menu_link: '메뉴 링크 제공',
        edit: '대기열의 고객 편집',
      },
      booking: {
        index: '예약',
        config: '예약 구성',
        able: '예약 허용',
        link: '예약 링크:',
        image_title: '이미지 정의',
        image_text:
          '예약 시스템은 2개의 이미지를 표시합니다. 레스토랑 사진을 업로드하거나 아래에서 기본 사진을 선택하십시오. 전송된 사진은 350x250 픽셀 크기로 조정됩니다.',
        image: '이미지',
        days_week: '요일',
        booking_day: '이 날짜에 예약을 허용하시겠습니까?',
        booking_day_text: '아래에 예약이 허용되는 시간을 정의하십시오.',
        booking_day_subtext:
          '시간을 선택하면 1시간 창이 정의됩니다. 예: 19:00를 선택하면 19:00에서 20:00 사이에 예약할 수 있습니다.',
        max_people: '예약당 최대 인원',
        max_people_text: '예약할 수 있는 그룹의 최대 크기입니다',
        expiry_time: '예약 만료까지의 최대 시간',
        expiry_time_text: '예약자가 도착할 때까지 기다릴 최대 시간(분)',
        day_confirm: '당일 확인 필수',
        day_confirm_text: '사용자는 선택한 날짜에 예약을 확인해야 합니다',
        payment_confirm: '예약 시 선불 결제 필수',
        value_payment_confirm: '선불 결제 금액',
        week: '주',
        month: '월',
        year: '년',
        use_terms: '동의 약관 활성화',
        empty: '현재 예약이 없습니다',
        use_time: '기간별 예약 허용',
        time: '예약 기간 (HH:mm)',
        time_cancel: '예약 취소 마감 시간 (HH:mm)',
        time_change: '예약 변경 마감 시간 (HH:mm)',
        use_change: '예약 시간 변경 허용',
      },
      booking_day: {
        booking: '당일 예약',
        date: '날짜',
        people: '명',
        expiry: '만료 시간',
        cancel_title: '취소',
        cancel_subtitle: '이 예약을 취소하시겠습니까?',
        cancel_button: '예약 취소',
        confirm_title: '확인',
        confirm_subtitle: '예약자의 도착을 확인하시겠습니까?',
        confirm_button: '도착 확인',
        accessibility_needs: '접근성 요구사항',
        accessibility_elderly: '노인 지원',
        accessibility_wheelchair: '휠체어 사용자',
        accessibility_physical: '신체 장애',
        filter_accessibility: '접근성으로 필터링',
        all_accessibility: '모든 요구사항',
      },
      booking_report: {
        report: '보고서',
        search: '예약 검색',
        time: '기간 선택',
        date_start: '시작일',
        date_end: '종료일',
        confirm: '확인',
        noShow: '미도착',
        confirmed: '확인된 예약',
        canceled: '취소된 예약',
        open: '미결',
        map: '예약 지도',
        booking: '예약',
        accessibility_stats: '접근성 통계',
        accessibility_total: '요구사항이 있는 총계',
        accessibility_percentage: '백분율',
      },
      booking_report_management: {
        management: '예약 관리',
        search: '예약 검색',
        phone: '전화',
        date_start: '시작일',
        date_end: '종료일',
        today: '오늘',
        tomorrow: '내일',
        calendar: '달력',
        see_all: '모두 보기',
        people: '명',
        noShow: '미도착',
        confirmed: '확인됨',
        canceled: '취소됨',
        open: '미결',
        search_text: '전화 검색 또는 날짜 선택 결과',
      },
      environment: {
        map: '환경 지도',
        environment: '환경',
        index: '환경',
        name: '환경 이름',
        tables: '테이블 수',
        seats_available: '사용 가능한 총 좌석',
        actions: '작업',
      },
      week_day: {
        sun: '일',
        mon: '월',
        tue: '화',
        wed: '수',
        thur: '목',
        fri: '금',
        sat: '토',
      },
      week_day_full: {
        sun: '일요일',
        mon: '월요일',
        tue: '화요일',
        wed: '수요일',
        thur: '목요일',
        fri: '금요일',
        sat: '토요일',
      },
      checkout: {
        title: '고객 데이터',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          '여기에 고객 생성에 필요한 필드가 나열됩니다.',
        active_mandatory: '필수 필드',
        active_visibility: '표시 가능한 필드',
      },

      liveShop: {
        liveShop: '라이브 커머스',
        liveShop_list: '여기에 라이브 커머스 이벤트와 해당 작업이 나열됩니다.',
        create: '라이브 커머스 생성',
        edit: '라이브 커머스 편집',
        dateInit: '시작',
        hourInit: '시작 시간',
        dateEnd: '종료',
        hourEnd: '종료 시간',
        status: '상태',
        initDate: '시작 날짜 및 시간',
        fimDate: '종료 날짜 및 시간',
        name: '이름',
        variations: '제품 변형',
        search_products_Attentions:
          '반환된 제품 및 변형은 활성 상태, 가격, 재고 및 이미지를 가지고 있어야 합니다',
        alert_delete: '라이브가 시작되었거나 종료된 경우 제거할 수 없습니다!',
        alert_Edit: '라이브가 시작되었거나 종료된 경우 편집할 수 없습니다!',
        delete: '라이브 커머스 삭제',
      },

      logs: {
        //PagSeguro
        pagseguroPaymentCodePhone: 'Pagseguro 전화 코드 오류',
        pagseguroPaymentErrorCountry: 'Pagseguro 국가 코드 오류',
        pagseguroPaymentErrorEmail: 'Pagseguro 이메일 오류',
        authenticatePagseguro: 'Pagseguro 인증',
        pagseguroPayment: 'Pagseguro 결제',
        pagseguroPaymentCatch: 'Pagseguro 결제',
        pagseguroPaymentResponse: 'Pagseguro 결제 응답',
        pagseguroPaymentTransactions: 'Pagseguro 결제 거래',
        pagseguroReturnPayment: 'Pagseguro 결제 반환',
        paymentPixPagseguro: 'Pagseguro Pix 결제',

        pagseguroPaymentGateway: 'Pagseguro 결제 게이트웨이',
        getAuthPagseguroEmailSpace: '이메일별 Pagseguro 인증',
        getOneApplicationClientId: 'Pagseguro 고객 응용 프로그램 가져오기',
        createAuthPagseguro: 'Pagseguro 인증 생성',
        generatePublicKeyPagseguro: 'Pagseguro 공개 키 생성',
        updateCodeRedirectApplication: 'Pagseguro 응용 프로그램 코드 업데이트',
        deleteAuthPagseguroByEmail: 'Pagseguro 인증 제거',
        createPluginconfig: '플러그인 구성',

        //Totvs 결제 HUB
        refundTotvs: 'Totvs를 통한 환불',
        refundPayCard: 'Totvs를 통한 카드 환불',
        paymentTotvs: 'Totvs를 통한 결제',
        paymentPixTotvs: 'Totvs를 통한 Pix 결제',

        //카드 구조
        sendUnregisteredCardBrands: '브랜드를 찾을 수 없습니다',
        cardStructure: '카드 구조',
        cardStructureInvalidPlugin: '게이트웨이에 유효하지 않은 플러그인',
        cardStructureGatewayError: '게이트웨이에 대한 카드 오류',
        cardStructureData: '카드 데이터',
        cardStructureError: '카드 데이터 오류',
        cardStructureDecrypt: '카드 복호화',
        cardStructureFields: '카드 필드',
        refundCard: '카드 환불',

        //상태
        analysisSatusOrder: '분석을 위한 주문 상태',
        statusPayPix: 'Pix 상태',

        //안티프라우드
        analyseAntifraud: '안티프라우드 분석',
        dataClearSale: 'ClearSale 데이터',
        statusAnalysis: '분석 상태',

        //재고
        addSkuInventory: '재고에 추가',
        subtractSku: '재고에서 제거',
        viewCargoHistory: '로드 내역 보기',
        viewCargoHistoryBySku: 'SKU별 로드 내역 보기',

        // 주문-Pedido
        sendOrderIn: '주문 발송',
        cancelOrder: '주문 취소',
        sendOrder: '주문 발송',
        sendOrderRefund: '주문 환불',
        sendOrderError: '주문 발송 중 오류 발생',
        sendOrderResultRefund: '주문 환불 결과',
        sendOrderResultData: '주문 발송 결과',
        sendOrderAntifrud: '주문 발송 시 안티프라우드',
        sendOrderPaymentStruct: '주문 결제 구조',

        sendOrderDescryptor: '주문 복호화',
        sendOrderStatus: '주문 상태',
        sendOrderConfigNotFound: '주문 발송 구성 없음',
        sendOrderMandatoryCustomer: '주문 고객',
        sendOrderMandatory: '주문 필수 구조',
        sendOrderResultGateway: '게이트웨이로 발송 결과',
        OrderFashionService: '패션 주문 서비스',
        OrderFashionServiceError: '패션 주문 서비스 오류',
        cartOrderLive: '라이브 주문 장바구니',
        cartOrderLiveError: '라이브 주문 장바구니 오류',
        sendOrderErrorGeral: '주문 오류',
        sendPushNotification: '푸시 알림 발송',

        //선주문
        preOrderStatusPix: 'Pix를 통한 선주문 상태',
        processQueuePreOrder: '선주문 큐 처리',
        getAllPreOrderBySpace: 'pluginspace별 모든 선주문 가져오기',
        sendPreOrder: '선주문 발송',
        makeOrderTransparent: '주문 확인',
        statusPreOrder: '선주문 Pix 상태 업데이트',
        preOrderStatusCanceledPix: 'Pix를 통한 선주문 취소',

        //Totvs Wintor
        buildOrderTotvsWinthor: '주문 생성',
        sendOrderWinthor: 'Totvs로 주문 발송',
        sendCustomerOrderWinthor: 'Totvs로 고객 발송',

        //Totvs Varejo
        buildOrderTotvsVarejo: '주문 생성',
        setConfimTicket: '티켓 확인',
        SyncOrderLive: '주문 동기화',
        ObterProdutos: '제품 가져오기',
        taskPrice: '가격 로드',
        calculationPromotion: '프로모션 계산',
        PayloadCalcPromotion: '프로모션 계산 Payload',

        //Totvs Moda
        changeStatus: '상태 변경',
        sendOrderFashion: 'Totvs로 주문 발송',
        sendCustomerFashion: 'Totvs로 고객 발송',
        searchPersonTotvsByCPF: 'Totvs 고객 검색',
        sendErrorCustomerFashion: '패션으로 고객 발송 중 오류 발생',
        buildCustomerTotvsFashion: 'Totvs에서 고객 생성',
        ResumeSnyOrderFashion: '패션과의 동기화 요약',
        changeStatusFashion: '상태 변경',
        buildOrderTotvsFashion: '패션 주문 생성',

        //Totvs Food
        updateStatusOrderFoodIntegration: '상태 변경',
        buildOrderTotvsFood: '주문 생성',
        changeStatusOrderFood: '상태 변경',
        sendOrderTotvsFood: 'Totvs로 주문 발송',
        confirmMenu: '메뉴 확인됨',
        getMenu: 'Totvs 메뉴 가져오기',

        //Totvs Live
        sendCustomerLive: '라이브 고객 발송',
        sendOrderLive: '라이브 주문 발송',

        //Synkar
        updateStatusOrderSynkar: 'Synkar 주문 업데이트',
        sendingOrderMessageSynkar: 'Synkar 메시지 발송',
        responseOrderMessageSynkar: 'Synkar 메시지 응답',
        sendingOrderSynkar: 'Synkar 발송',
        responseOrderSynkar: 'Synkar 응답',

        //SDS
        sdsGetOrders: 'SDS 주문 가져오기',
        sdsOrderIn: 'SDS 주문 발송',
        sdsOrderInResult: 'SDS로 주문 발송',
        sdsSyncCardapio: '메뉴와 SDS 동기화',
        'sendOrderfood-sdsOrderIn': 'SDS 주문 발송 중 오류 발생',

        //S3
        createRoute: 'S3 경로 생성',
        getStatusfiftythree: '경로 53 상태',
        updateDistribution: '배포 업데이트',
        deleteRoute: 'S3 경로 삭제',
        deleteDistribution: '배포 삭제',

        //Erede
        refundErede: 'Erede 환불',
        paymentErede: 'Erede 결제',

        //Cielo
        refundCielo: 'Cielo 환불',
        paymentCielo: 'Cielo 결제',

        //Pagseguro
        refundPagseguro: 'Pagseguro 환불',
        getApplicationPagseguro: 'Pagseguro 애플리케이션 게이트웨이',

        //오프라인 결제
        paymentOffline: '배송 시 결제',

        //일반
        chargeSyncOrderErro: '상태 동기화 오류',
        chargeSyncOrder: '상태 동기화',
        chargeProductLive: '라이브 제품 동기화',
        chargeBalanceLive: '라이브 재고 동기화',
        chargePriceLive: '라이브 가격 동기화',
        chargeProductLiveErro: '라이브 제품 동기화 오류',
        chargeBalanceLiveErro: '라이브 재고 동기화 오류',
        chargePriceLiveErro: '라이브 가격 동기화 오류',

        chargeProduct: '제품 동기화',
        chargeBalance: '재고 동기화',
        chargePrice: '가격 동기화',
        chargeProductErro: '제품 동기화 오류',
        chargeBalanceErro: '재고 동기화 오류',
        chargePriceErro: '가격 동기화 오류',

        taskBalanceIntegration: '재고 로드 통합',
        taskBalanceCharge: '재고 로드 시작됨',
        SnyOrder: '주문 상태 동기화',
        syncronyzePriceInteration: '가격 로드',
        syncronyzePrice: '가격 동기화',
        chargeClassification: '카테고리 및 하위 카테고리 로드',
        chargeGrid: '그리드 로드',
        chargeGridItens: '그리드 로드 항목',
        chargeMeasure: '측정 단위 로드',
        deleteAllProducts: '모든 제품 삭제',

        chargeGridToken: '그리드 로드 토큰',
        classificationChargeToken: '분류 로드 토큰',
        syncronyzeBalanceToken: '재고 동기화 토큰',
        syncronyzePriceToken: '가격 동기화 토큰',
        chargeMeasureToken: '측정 단위 로드 토큰',
        taskClassificationBySpace: '분류 로드',
        syncStatusOrderPayload: '주문 상태 동기화 Payload',
        syncStatusOrder: '주문 상태 동기화',
        syncStatusOrderToken: '주문 상태 동기화 토큰',
        syncronyzeBalancePayload: '재고 동기화 Payload',
        syncronyzeBalance: '재고 동기화',
        taskBalanceChargeBySpace: '재고 로드',
        syncronyzePricePayload: '가격 동기화 Payload',
        priceSkuVariationItens: '변형 항목의 가격',
        configSyncOrderBySpace: '주문 동기화 구성',
        configSyncOrder: '주문 동기화 구성',
        taskGridChargeBySpace: '그리드 로드',
        productChargeInternal: '제품 로드',
        taskChargeProductBySpace: '제품 로드',
        skuLocationVariation: '위치별 변형 동기화',
        stockSkuVariation: '변형 동기화',
        taskPriceChargeBySpace: 'Pluginspace별 가격 로드',

        automaticChargeBalance: '자동 재고 동기화',
        automaticChargePrice: '자동 가격 동기화',
        automaticChargeClassification: '자동 분류 동기화',
        automaticTaskGridCharge: '자동 그리드 동기화',
        automaticTaskMeassure: '자동 측정 단위 동기화',
        automaticSnyOrder: '자동 주문 상태 동기화',
        chargeMeasureItens: '측정 단위 로드 항목',
        searchMeasurementAll: '측정 단위 로드',
        taskGridCharge: '그리드 로드',
        taskMeassure: '측정 단위 로드',

        getCredential: '토큰 가져오기',
        LoadPricePerList: '가격 로드',
        processPriceList: '가격 목록 처리',
        updateProductKit: '제품 업데이트',
        UpdateProductSingle: '제품 업데이트',
        updateProductStatus: '제품 상태 업데이트',
        taskBalanceIntegrationLink: '재고 통합 링크',
        taskPriceIntegrationLink: '가격 통합 링크',
        taskProductIntegrationLink: '제품 통합 링크',
        token: '토큰 획득',
        automaticChargeProduct: '자동 제품 로드',

        //Ninegrid 할인
        calculateDiscount: 'ninegrid의 할인 계산',
        sendDiscountNinegrid: 'Ninegrid 할인',

        //고객 장바구니
        updateCustomerCartStatus: '고객 장바구니 업데이트',

        //고객
        createCustomer: '고객 생성',
        validCodeCustomer: '고객 유효성 검사 코드',

        //clearSale
        statusAnalisis: '상태 분석',
        antifraudValidation: '안티프라우드 유효성 검사',
        clearSale: 'ClearSale 보장',
        searchOrderStatusClearSale: 'ClearSale 상태 검색',

        printLabelFrenet: 'Frenet 라벨',
        changeStatusFrenet: 'Frenet 상태 변경',
        callWaiter: '웨이터 호출',
        paymentTable: '테이블에서 결제',

        // 셰프 송장 생성
        generateNfOrderFood: '주문 송장 생성',
        getNotaFiscalChef: '셰프 송장 검색',
        finishOrderFood: '송장 전 확인',

        // 셰프 주문 오류 로그
        buildCardData: '커맨드 데이터 생성 중 오류 발생',
        buildTableData: '테이블 데이터 생성 중 오류 발생',
        buildTablePaymentData: '테이블 결제 데이터 생성 중 오류 발생',
        buildCounterData: '카운터 데이터 생성 중 오류 발생',
        buildDeliveryData: '배송/픽업 데이터 생성 중 오류 발생',

        generateCustomerWholeSalerByCSV: 'CSV별 도매 고객 생성',

        validateStockWholeSaleCart: '주문 경고',
        validateWholeSaleCart: '주문 경고',

        chargeImageService: '이미지 로드 서비스',

        webhookNisRedis: '상점 Redis 정리',

        /*이메일 발송  */
        sendEmailWelcome: '환영 이메일 발송',
        sendEmailOrderNotification: '주문 이메일 알림 발송',
        sendEmailAccountNotification: '계정 이메일 알림 발송',
        createCustomerLogin: '고객 로그인 생성 이메일 발송',
        /*Seller Queue */
        sellerOrderFilterPDVTotvsPersistResponse: 'PDV Totvs 주문 필터 지속',
        sellerOrderFilterPDVTotvsPersistRequest: 'PDV Totvs 주문 필터 요청',
      },

      copy: {
        definition: 'Pluginspace 정의',
        origin: '원본 Pluginspace 선택',
        destination: '대상 Pluginspace 선택',
        configurations: '복사 구성',
        store: '상점 설정',
        deliveryFee: '배송 수수료',
        shifts: '교대 근무',
        paymentPlans: '결제 계획',
        clientData: '고객 데이터',
        account: '계정 구성',
        groups: '그룹',
        terms: '약관',
        webapp: '웹 앱',
        webappConfig: '구성',
        webappPersonalize: '개인화',
        whatsappweb: 'WhatsApp 웹',
        whatsappwebConfig: '구성',
        whatsappwebPersonalize: '개인화',
        integrations: '통합',
        integrationPayment: '결제 수단',
        integrationPdv: 'POS',
        integrationMessaging: '메시징',
        integrationOthers: '기타',
        button: 'Pluginspace 복사',
      },

      payment: {
        methods: '결제 수단',
        method: '결제 형태',
        gateway: '결제 게이트웨이',
        card: '신용 카드',
        debit: '직불 카드',
        food: '식사권',
        pix: 'Pix',
        others: '기타',
        pay_money: '현금',
        config: '구성',
        add: '결제 수단 구성',
        back: '결제 게이트웨이로 돌아가기',
        basic_settings: '기본 구성',
        modalities: '이 결제 수단이 사용될 모달리티',
        add_payment: '결제 형태 추가',
        code_erp: 'ERP 코드',
        installments: '할부 횟수',
        edit_payment: '결제 형태 편집',
        delete: '결제 형태 삭제',
        money: '현금 결제',
        max_installments: '최대 할부 횟수는 얼마입니까?',
        min_value_installments: '할부의 최소 금액은 얼마입니까?',
        confirm: '삭제 확인',
        delete_payment: '결제 형태를 삭제하시겠습니까',
        change: '이 교환을 수행하시겠습니까?',
        inative: '이 결제 형태를 비활성화하시겠습니까?',
        inative_change: '이 결제 형태를 활성화하고 이전 형태를 비활성화하시겠습니까?',
        motive: '사유를 알려주십시오',
        /* 할인에 사용됨 */
        config_descount_payment: '결제 수단별 할인 구성',

        able_discount_pix: 'Pix 결제 할인 활성화',
        able_discount_card: '카드 결제 할인 활성화',
        able_discount: '결제 할인 활성화',

        discount_percentage: '백분율 할인',
        discount_monetary: '금액 할인',
        discount_value: '할인 금액',
      },

      icon: {
        title: '아이콘',
        subtitle: '여기에 라이브러리의 모든 아이콘이 나열됩니다',
      },
      freight: {
        title: '발송 모달리티',
        map: '지도',
        map_text: '주문 배송 시 결제 옵션',
        range: '반경',
        range_text: '주문 배송 시 결제 옵션',
        cep: '우편번호 목록',
        cep_text: '주문 배송 시 결제 옵션',
        config: '구성',
        delivery: '자체 배송',
        delivery_text: '3가지 사용자 지정 가능한 배송 옵션이 있습니다:',
        frenet: 'Frenet',
        frenet_text: '다양한 운송업체 및 배송 수단을 통한 완벽한 운송 관리.',
        frenet_text_2: '이 통합을 활성화하려면 Frenet 요금제가 필요합니다.',
        site: '공식 웹사이트 보기',
        coming_soon: '출시 예정...',
      },
      frenet: {
        title: 'Frenet과 통합',
        back: '배송 수단으로 돌아가기',
        integration: '통합',
        config: '구성',
        dimensions: '센티미터 단위의 기본 배송 크기',
        height: '높이',
        width: '너비',
        length: '길이',
        value: '제품 신고 가격',
        use: '사용',
        dont_use: '사용 안 함',
        price: '간소화된 견적을 사용하시겠습니까?',
        yes: '예',
        no: '아니오',
        branchCode: 'Jadlog 우편물 접수 지점',
        no_balance: 'Frenet에 잔액이 없습니다',
        value_balance: 'Frenet에 @ 잔액이 있습니다',
        print_balance: '이 주문의 배송 라벨을 인쇄하려면 Frenet 계정에 잔액을 충전해야 합니다.',
        click_balance: '아래 버튼을 클릭하여 다른 탭에서 Frenet에 액세스하십시오.',
        open_balance: 'Frenet 계정 열기',
        valid_token: '토큰이 유효하지 않습니다',
        declared_value: '신고 가격은 운송업체의 보험료에 사용됩니다.',
        getToken:
          'Frenet에서 토큰을 찾으려면 액세스 키 섹션에 액세스하여 "TOKEN" 필드의 값을 복사해야 합니다.',
        weight_frenet: '표준 무게 (kg)',
        height_frenet: '표준 높이 (cm)',
        width_frenet: '표준 너비 (cm)',
        depth_frenet: '표준 깊이 (cm)',
        alert_title: '운임 계산을 위한 참조 치수',
        alert_warning: '주의!',
        alert_description: '이 측정값은 등록된 부피가 없는 제품의 운임을 계산하는 데 사용됩니다.',
        alert_wrong_values: '잘못된 값은 다음을 생성할 수 있습니다:',
        alert_overpriced: '과도하게 청구된 운임 (고객 이탈).',
        alert_additional_costs: '추가 비용 (운송업체가 나중에 값을 조정하는 경우).',
        alert_recommendation: '각 제품의 실제 부피를 등록하는 것이 좋습니다.',
        alert_reference: '참조 치수:',
        alert_small_products: '작은 제품',
        alert_small_examples: '(예: 액세서리, 모조 장신구, 케이블)',
        alert_small_weight: '무게: 0.1–0.3 kg',
        alert_small_dimensions: '치수: 10 × 10 × 5 cm',
        alert_medium_products: '중간 제품',
        alert_medium_examples: '(예: 의류, 도서, 소형 전자 제품)',
        alert_medium_weight: '무게: 0.5–2 kg',
        alert_medium_dimensions: '치수: 25 × 20 × 10 cm',
        alert_large_products: '대형 제품',
        alert_large_examples: '(예: 가전 제품, 부피가 큰 상자)',
        alert_large_weight: '무게: 5–20 kg 이상',
        alert_large_dimensions: '치수: 50 × 40 × 30 cm 이상',
      },
      chat: {
        you: '당신',
        now: '지금 전송됨',
        send: '보내기',
        type_message: '메시지를 보내십시오...',
        initial_message: 'Ninegrid AI 채팅에 오신 것을 환영합니다',
        error_message:
          '메시지에 대한 답변을 찾을 수 없습니다. 더 구체적이거나 나중에 다시 시도하십시오.',
        tip_language: '한국어로 답변하십시오.',
        title_config: '인공 지능 구성',
        config: '인공 지능 구성',
        fit: '인공 지능 교육',
        fit_header: '여기에 질문과 해당 생성된 답변이 나열됩니다',
        add_question: '질문 추가',
        edit_question: '질문 편집',
        delete_question: '아래 질문을 삭제하시겠습니까?',
        question: '질문',
        answer: '답변',
        date: '날짜',
        actions: '작업',
        active: '활성',
        delete: '삭제',
        sync: 'AI 동기화',
        upload: '파일 업로드',
        about: '정보',
        chatia: '채팅',
        about_title: 'Ninegrid AI 정보',
        about_description_title: '설명',
        about_description: 'Ninegrid AI는 지원 작업을 돕기 위해 설계된 지능형 가상 비서입니다.',
        about_support_title: '지원',
        about_support_description:
          '궁금한 점이 있거나 도움이 필요하면 지원팀이 도와드릴 준비가 되어 있습니다.',
        about_support_contact_1: '지원팀에 문의하려면 이메일로 연락하거나',
        about_support_contact_2: '포털에서 호출을 개설하십시오:',
        about_features_title: '기능',
        tips: '질문을 만드는 팁',
        about_tips_1: '명확하고 객관적인 질문을 사용하여 더 나은 답변을 얻으십시오.',
        about_tips_2: '속어나 복잡한 기술 용어는 피하십시오.',
        about_tips_3: '답변이 만족스럽지 않으면 질문을 다시 작성해 보십시오.',
        about_tips_4: 'Ninegrid AI는 상호 작용을 통해 학습하므로 더 많이 사용할수록 향상됩니다.',
        feature_1: '자연어 대화',
        feature_2: '음성 명령 지원',
        feature_3: '응답을 위한 음성 합성',
        feature_4: '직관적이고 반응이 빠른 인터페이스',
        about_manuals: '매뉴얼',
        about_manuals_description:
          'Ninegrid 환경 사용 방법에 대한 자세한 내용은 매뉴얼을 확인하십시오.',
        about_faq: '자주 묻는 질문',
        about_faq_description: '자주 묻는 질문과 답변을 확인하여 일반적인 의문점을 해소하십시오.',
        about_version_title: '시스템 정보',
        version: '버전',
        last_update: '최종 업데이트',
        rights_reserved: '모든 권리 보유',
        access_here: '여기 액세스',
        our_faq: '자주 묻는 질문 보기',
        or: '또는',
        and: '그리고',
      },
      sumary_access: {
        cart: '장바구니',
        seller: '판매자 로그인',
        category: '카테고리',
        pdv: '제품 세부 정보',
        subcategory: '하위 카테고리',
        product: '제품 목록',
        home: '초기 화면',
        'search-order': '주문',
        'store-info': '상점 정보',
        customer: '고객 등록',
        receipt: '결제 영수증',
        order: '결제',
        card: '카드 결제',
        'order-qrcode': '고객 Pix 결제',
        'success-order': '구매 성공',
        'filter/pdv': '필터 결과',
        filter: '필터 선택',
        'seller-qrcode': '결제 링크',
        'vendor-order ': '판매자 장바구니 조회',
        'finalize-order': '구매 요약',
      },
      optional: {
        optionals: '추가 항목',
        list: '추가 항목 목록',
        name: '이름',
        used: '사용됨',
        config: '구성',
        link: '제품 연결',
        products_optional: '목록과 연결된 제품',
        edit: '추가 항목 목록 편집',
        type: '선택 유형',
        max: '최대',
        mandatory: '필수',
        order: '순서',
        code: '코드',
        qtd: '최대 수량',
        price: '가격',
        include: '추가 항목 포함',
        create: '추가 항목 목록 생성',
        description: '웹 앱 설명',
        emptyProduct: '이 추가 항목을 사용하는 제품이 없습니다',
      },

      coupons: {
        title: '쿠폰',
        report: '쿠폰 보고서',
        titleCreate: '쿠폰 생성',
        titleUpdate: '쿠폰 편집',
        subTitle: '여기에 쿠폰과 해당 작업이 나열됩니다.',
        create: '쿠폰 생성',
        edit: '쿠폰 편집',
        delete: '쿠폰 삭제',

        //입력 변수
        name: '쿠폰 이름',
        name_helper: '최대 15자',
        description: '설명',
        description_placeholder: '최대 200자여야 합니다',
        seller: '판매자',
        catalog: '카탈로그',
        discountValue: '할인 금액',
        discountPercentage: '할인 비율',
        type: '유형',
        dateInit: '시작일',
        dateEnd: '종료일',
        quantitative: '사용 횟수',
        typeOptions: {
          all: '모든 유형',
          classification: '분류',
          product: '제품',
          individuality: '개인',
          exclusive: '독점',
          quantitative: '정량적',
          periodical: '정기적',
          cupomday: '쿠폰의 날',
        },
        filters: '필터',
        status: '상태',
        selectStatuses: '상태 선택',
        actions: {
          filter: '필터',
          export: '내보내기',
        },
        quick: {
          today: '오늘',
          week: '이번 주',
          month: '이번 달',
          lastMonth: '지난 달',
          year: '올해',
        },
        stats: {
          title: '일반 통계',
          totalCoupons: '총 쿠폰',
          activeCoupons: '활성 쿠폰',
          totalUsages: '총 사용량',
          totalDiscount: '총 할인액',
        },
        distribution: {
          title: '유형별 분포',
        },
        monthlyUsage: {
          title: '월별 사용량',
        },
        series: {
          usageCount: '사용 횟수',
          numberOfUses: '사용 횟수',
          discountValue: '할인 금액',
        },
        table: {
          details: '쿠폰 세부정보',
        },
        statusLabels: {
          true: '활성',
          false: '비활성',
        },
        statusOptions: {
          all: '모두',
          active: '활성',
          inactive: '비활성',
          expired: '만료됨',
        },
      },

      order_print: {
        title: '인쇄를 확인하기 전에 주문 정보를 확인하십시오',
        print_text: '인쇄',
        information:
          'QZ Tray가 연결을 설정하기 위한 권한을 요청합니다. "허용"을 클릭하여 인쇄를 진행하십시오.',
        order_details: '주문 세부 정보',
        client: '고객',
        payment: '결제',
        created: '생성됨',
        print: '주문 인쇄',
        print_confirm:
          '이 주문을 인쇄하시겠습니까? 계속 진행하기 전에 프린터가 연결되어 있고 올바르게 구성되었는지 확인하십시오',
      },

      whatsappweb: {
        title: 'WhatsApp 웹',
        subtitle: '여기에 WhatsApp 구성과 해당 작업이 나열됩니다.',
        titleCreate: 'WhatsApp 동기화',
        titleDelete: 'WhatsApp 동기화 제거',
        create: 'WhatsApp 동기화',
        delete: 'WhatsApp 세션 삭제',
        active: '활성',
        welcome: 'Ninegrid WhatsApp 웹',
        describe_whatsappweb: '여기에서 WhatsAppWEB을 상점 휴대폰과 연결할 수 있습니다!',
        config: 'WhatsApp 구성',
        step1: '휴대폰에서 WhatsApp을 엽니다.',
        step2: 'Android에서는 더 많은 옵션 ⋮을 탭하거나 iPhone에서는 설정 ⚙️을 탭합니다.',
        step3: '연결된 기기를 탭한 다음 기기 연결을 탭합니다.',
        step4: '휴대폰을 이 화면으로 가리켜 QR 코드를 스캔합니다.',
      },
      fileManagement: {
        title: '파일 관리자',
        subtitle: '여기에 파일과 해당 작업이 나열됩니다.',
        create: '파일 생성',
        edit: '파일 편집',
        delete: '파일 삭제',
        download: '파일 다운로드',
        upload: '파일 발송',
        file: '파일',
        file_name: '파일 이름',
        file_item: '항목',
        file_itens: '항목',
        file_type: '파일 유형',
        file_size: '파일 크기',
        file_date: '생성일',
        file_actions: '작업',
        file_folder: '폴더',
        file_new_folder: '새 폴더',
        file_folder_name: '폴더 이름',
        file_last_modified: '최종 수정',
        file_description: '파일 설명',
        file_description_placeholder: '파일 설명',
        file_description_helper: '최대 200자',
        file_name_placeholder: '파일 이름',
        file_name_helper: '최대 15자',
        file_page_showing: '표시',
        file_not_found: '파일을 찾을 수 없습니다',
        file_uploading: '파일 로드 중',
        file_upload: '파일 로드',
        file_changing: '파일 변경 중',
        file_Loading: '파일 로드 중',
        file_update: '업데이트',
        file_sync_knowledge_base: '지식 기반 동기화',
        file_history_sync: '동기화 내역',
        scanned: '스캔됨',
        indexed: '인덱싱됨',
        modified: '수정됨',
        completed: '완료됨',
        deleted: '삭제됨',
        failed: '실패함',
        available: '사용 가능',
        last_update: '최종 업데이트',
        status: '상태',
        status_job: '작업 상태',
        data_source: '데이터 소스',
        knowledge_base: '지식 기반',
        history_sync: '동기화 내역',
        chart_scanned_doc: '스캔된 문서',
        chart_indexed_doc: '인덱싱된 문서',
        chart_modified_doc: '수정된 문서',
        chart_deleted_doc: '삭제된 문서',
        chart_failed_doc: '실패한 문서',
        chart_docs_processed: '처리된 문서',
        chart_docs_total: '총 문서 수',
        total_jobs_processed: '처리된 총 작업 수',
        jobs_info: '작업에 대한 정보',
        observation_table_jobs_phase:
          '처리된 작업 테이블은 각 데이터 소스의 최근 5개 작업을 보여줍니다.',
      },
      service_requests: {
        title: '서비스 양식',
        subtitle: '서비스 요청 양식 관리',
        create: '서비스 양식 생성',
        edit: '서비스 양식 편집',
        delete: '서비스 양식 삭제',
        create_form: '양식 생성',
        edit_form: '양식 편집',
        delete_form: '양식 삭제',
        form_title: '제목',
        form_icon: '아이콘',
        form_status: '상태',
        form_description: '설명',
        form_components: '구성 요소',
        form_grids: '그리드',
        priority_label: '우선순위',
        priority_low: '낮음',
        priority_normal: '보통',
        priority_high: '높음',
        priority_critical: '긴급',
        choose_icon: '선택',
        add_component: '추가',
        sections: '섹션',
        empty_message: '추가를 클릭하여 구성 요소를 삽입하고 드래그하여 순서를 재정렬하십시오.',
        success_created: '서비스 양식이 성공적으로 생성되었습니다.',
        success_updated: '서비스 양식이 성공적으로 업데이트되었습니다.',
        success_deleted: '서비스 양식이 성공적으로 삭제되었습니다.',
        error_create: '서비스 양식 생성 중 오류가 발생했습니다.',
        error_update: '서비스 양식 업데이트 중 오류가 발생했습니다.',
        error_delete: '서비스 양식 삭제 중 오류가 발생했습니다.',
        error_load: '로드 중 오류 발생!',
        validation_title: '세션 제목을 알려주십시오',
        validation_icon: '세션 아이콘을 선택하십시오',
        validation_components: '저장하기 전에 하나 이상의 구성 요소를 추가하십시오',
        placeholder_title: '예: 청소',
        icon_selected: '선택된 아이콘 (SVG)',
        icon_none: '선택된 아이콘 없음',
        visual_instructions:
          '세션을 시각적으로 조립하십시오. 드래그하여 순서를 재정렬하십시오. 필드는 시각적일 뿐입니다(비대화형).',
        component: '구성 요소',
        components_plural: '구성 요소',
        grid: '그리드',
        grids_plural: '그리드',
        grid_services: '서비스 그리드',
        grid_services_title: '서비스 그리드 선택',
        grid_services_search: '그리드 검색',
        grid_services_label: '그리드',
        grid_services_selected: '선택된 그리드',
        grid_services_error: '호텔 그리드 검색 중 오류 발생',
        add_component_modal: '구성 요소 추가',
        validation_grids_required: '필수 그리드',
        validation_grids_text:
          '모든 선택 구성 요소는 하나 이상의 선택된 서비스 그리드를 가져야 합니다.',
        actions: '작업',
        breadcrumb_dashboard: '대시보드',
        breadcrumb_essential_services: '필수 서비스',
        // UI 요소
        drag_title: '드래그',
        drag_action: '드래그',
        remove_title: '제거',
        remove_aria_label: '블록 제거',
        max_quantity_title: '최대 수량:',
        max_prefix: '최대:',
        description_label: '설명',
        sections_label: '섹션',
        // 모달 제목 및 작업
        select_icon_title: '선택',
        no_icons_available: '사용 가능한 아이콘이 없습니다…',
        search_placeholder: '검색하려면 입력하십시오...',
        grid_services_selected_label: '선택됨:',
        no_grid_found: '그리드를 찾을 수 없습니다',
        no_grid_available: '사용 가능한 그리드가 없습니다',
        grid_status_active: '활성',
        grid_status_inactive: '비활성',
        grid_item_name_placeholder: '이름(예: 릴랙싱 마사지)',
        grid_item_value_placeholder: '금액(예: 50.00)',
        cancel_button: '취소',
        save_button: '저장',
        confirm_button: '확인',
        // 수량 모달
        max_quantity_modal_title: '최대 수량 정의',
        max_quantity_label: '최대 수량',
        max_quantity_placeholder: '최대 수량을 입력하십시오',
        max_quantity_helper: '이 필드에서 선택할 수 있는 최대 항목 수를 정의합니다.',
        // 브레드크럼
        breadcrumb_create: '생성',
        breadcrumb_edit: '편집',
        // 양식 구성 요소
        sample_service_1: '서비스 1',
        sample_service_2: '서비스 2',
        sample_hygiene: '위생',
        sample_drinks: '음료',
        room_number_label: '객실 번호',
        select_placeholder: '선택...',
        date_label: '날짜',
        hour_label: '시간',
        quantity_label: '수량',
        between_placeholder: '사이',
        and_placeholder: '와',
        select_list_label: '선택 (목록)',
        select_item_placeholder: '항목 선택',
        select_checkbox_label: '선택 (체크박스)',
        // Visibility
        visible_to_label: '표시 대상',
        visible_to_employees: '직원',
        visible_to_customers: '고객',
        visible_to_both: '둘 다',
        select_category_placeholder: '카테고리 선택',
        select_quantity_label: '선택 (수량)',
        qty_label: '수량',
        // 카탈로그 제목
        catalog_room_number: '객실 번호',
        catalog_date: '날짜',
        catalog_hour: '시간',
        catalog_date_hour: '날짜 + 시간',
        catalog_select_list: '선택 (목록)',
        catalog_select_list_quantity: '선택 (목록) + 수량',
        catalog_select_checkbox: '선택 (체크박스)',
        catalog_select_count: '선택 (수량)',
        catalog_quantity: '수량',
      },
      base_modal: {
        attention_title: '주의!',
        unsaved_changes_text: '변경 사항이 손실됩니다. 나가시겠습니까?',
        confirm_button: '예',
        cancel_button: '아니오',
      },
      summarize_ia: {
        title: 'AI 사용 요약',
        subtitle: '여기에 AI 요약 정보가 나열됩니다.',
        create: 'AI 요약 생성',
        edit: 'AI 요약 편집',
        delete: 'AI 요약 삭제',
        summarize: '요약',
      },
      hospitality: {
        add_room: '객실 추가',
        create_multiples: '여러 개 생성',
        add_activity: '활동 추가',
        add_experience: '체험 추가',
        experiences: '체험',
        experience_type: '체험 유형',
        experience_duration: '기간',
        experience_price: '가격',
        experience_rating: '평가',
        experience_includes: '포함',
        create_experience: '체험 생성',
        edit_experience: '체험 편집',
        experience_created: '체험 생성 성공!',
        experience_updated: '체험 업데이트 성공!',
        experience_deleted: '체험 삭제 성공!',
      },
      hospitality_content: {
        page_title: '버튼',
        page_subtitle: '여기에 섹션의 버튼이 나열되어 있습니다.',
        add_button: '버튼 추가',
        filters: {
          sections: '섹션',
        },
        table: {
          headers: {
            title: '제목',
            order: '순서',
            formTitle: '폼 제목',
            type: '유형',
            visibility: '가시성',
            actions: '작업',
          },
        },
        tabs: {
          buttons: '버튼',
          native_buttons: '기본 버튼',
        },
        actions: {
          edit: '버튼 편집',
          delete: '버튼 삭제',
          delete_confirm: '이 버튼을 삭제하시겠습니까?',
        },
        type_labels: {
          service_form: '서비스 폼',
          feedback: '귀하의 의견',
          service: '서비스',
          information: '정보',
          activities_leisure: '활동 및 레저',
          bars_restaurants: '바 및 레스토랑',
          schedule: '예약',
          experience: '경험',
          booking: '일정',
          check_in: '체크인',
          check_out: '체크아웃',
          tours: '관광',
          page_dynamic: '동적 페이지',
        },
        no_category: '카테고리 없음',
        messages: {
          filter_error_title: '오류',
          filter_error_text: '섹션 필터링 오류',
          load_error_title: '로드 오류',
          load_error_text: '섹션 로드 실패!',
          section_not_found_title: '오류',
          section_not_found_text: '섹션을 찾을 수 없습니다!',
          deleted_title: '섹션 삭제됨',
          deleted_text: '삭제가 성공적으로 완료되었습니다!',
          delete_error: '섹션 삭제 오류!',
          visibility_updated_title: '가시성 업데이트됨',
          visibility_updated_text: '버튼 가시성이 성공적으로 업데이트되었습니다!',
          visibility_error_title: '업데이트 오류',
          visibility_error_text: '버튼 가시성 업데이트 오류!',
          form: '폼',
          page: '페이지',
        },
        create_modal: {
          modal_title: '콘텐츠 추가',
          alert_title: '섹션 및 콘텐츠 선택',
          alert_subtitle: '해당하는 섹션과 콘텐츠를 선택하세요.',
          label_section: '섹션',
          label_content: '콘텐츠',
          placeholder_select: '선택',
          placeholder_select_section: '섹션 선택',
          placeholder_select_content: '콘텐츠 선택',
          order_label: '순서',
          selection_summary: '선택 요약:',
          badge_section: '섹션',
          badge_content: '콘텐츠',
          select_form_label: '폼 선택 (roomService)',
          tips_title: '팁',
          tips: {
            item1: '섹션은 여러 콘텐츠를 가질 수 있습니다',
            item2: '콘텐츠는 여러 섹션에 속할 수 있습니다',
            item3: '순서는 목록에서의 위치를 정의합니다',
          },
          buttons: {
            cancel: '취소',
            create: '생성',
          },
          swal: {
            missing_field_title: '필수 필드 누락',
            missing_section: '계속하려면 섹션을 선택하세요',
            missing_content: '계속하려면 콘텐츠를 선택하세요',
            invalid_field_title: '유효하지 않은 필드',
            invalid_order: '순서는 양수 또는 0이어야 합니다',
            created_title: '콘텐츠 등록됨',
            created_text: '등록이 성공적으로 완료되었습니다!',
            create_error: '콘텐츠 등록 오류!',
          },
        },
        edit_modal: {
          modal_title: '콘텐츠 편집',
          alert_title: '콘텐츠 편집',
          alert_subtitle: '필요에 따라 섹션과 순서를 변경하세요. 현재 콘텐츠는 변경할 수 없습니다.',
          label_section: '섹션',
          label_content: '콘텐츠',
          placeholder_select: '선택',
          placeholder_select_section: '섹션 선택',
          placeholder_select_content: '콘텐츠 선택',
          order_label: '순서',
          selection_summary: '선택 요약:',
          badge_section: '섹션',
          badge_content: '콘텐츠',
          tips_title: '팁',
          tips: {
            item1: '섹션만 변경할 수 있습니다',
            item2: '순서는 목록에서의 위치를 정의합니다',
          },
          buttons: {
            cancel: '취소',
            save: '저장',
          },
          swal: {
            missing_field_title: '필수 필드 누락',
            missing_section: '계속하려면 섹션을 선택하세요',
            missing_content: '계속하려면 콘텐츠를 선택하세요',
            invalid_field_title: '유효하지 않은 필드',
            invalid_order: '순서는 양수 또는 0이어야 합니다',
            updated_title: '콘텐츠 업데이트됨',
            updated_text: '업데이트가 성공적으로 완료되었습니다!',
            update_error: '콘텐츠 업데이트 오류!',
          },
        },
        category: {
          page_title: '섹션',
          page_subtitle: '여기에 콘텐츠 섹션과 해당 작업이 나열되어 있습니다.',
          add_button: '추가',
          breadcrumbs: {
            dashboard: '대시보드',
            categories: '카테고리',
          },
          table: {
            headers: {
              section: '섹션',
              order: '순서',
              status: '상태',
              actions: '작업',
            },
          },
          options: {
            edit_category: '카테고리 편집',
            delete_section: '섹션 삭제',
            delete_confirm: '섹션 삭제',
          },
          swal: {
            deleted_title: '섹션 삭제됨',
            deleted_text: '삭제가 성공적으로 완료되었습니다!',
            delete_error: '섹션 삭제 오류!',
          },
          create: {
            missing_fields_title: '필수 필드 누락',
            missing_fields_text: '모든 필드를 올바르게 채웠는지 확인하십시오!',
            created_title: '카테고리 등록됨',
            created_text: '등록이 성공적으로 완료되었습니다!',
            create_error: '카테고리 등록 오류!',
          },
          update: {
            missing_fields_title: '필수 필드 누락',
            missing_fields_text: '모든 필드를 올바르게 채웠는지 확인하십시오!',
            updated_title: '카테고리 업데이트됨',
            updated_text: '편집이 성공적으로 완료되었습니다!',
            update_error: '카테고리 업데이트 오류!',
          },
          type: {
            default: '표준 버튼',
            banner: '추천 배너',
          },
        },
      },
      clean_safe: {
        title: '청결 및 안전',
        subtitle: '안전 조치, 청소 프로토콜 및 인증 관리',
        security_measures: '안전 조치',
        cleaning_protocols: '청소 프로토콜',
        certifications: '인증',
        add_security_measure: '조치 추가',
        add_cleaning_protocol: '프로토콜 추가',
        add_certification: '인증 추가',
        add_new_security_measure: '새 조치 추가',
        add_new_cleaning_protocol: '새 프로토콜 추가',
        add_new_certification: '새 인증 추가',
        security_measure: '안전 조치',
        cleaning_protocol: '청소 프로토콜',
        certification: '인증',
        icon: '아이콘',
        choose_icon: '아이콘 선택',
        title_field: '제목',
        description: '설명',
        status: '상태',
        active: '활성',
        inactive: '비활성',
        remove: '제거',
        save: '저장',
        required_title: '제목은 필수입니다',
        required_icon: '아이콘은 필수입니다',
        required_fields: '필수 필드',
        required_fields_message: '모든 필수 필드를 작성하십시오.',
        confirmation: '확인',
        delete_security_measure_confirm: '이 안전 조치를 삭제하시겠습니까?',
        delete_cleaning_protocol_confirm: '이 청소 프로토콜을 삭제하시겠습니까?',
        delete_certification_confirm: '이 인증을 삭제하시겠습니까?',
        yes: '예',
        no: '아니오',
        error: '오류',
        error_delete: '항목 삭제 중 오류 발생.',
        success: '성공',
        success_save: '위생 및 안전 데이터 저장 성공!',
        error_save: '데이터 저장 중 오류 발생.',
        empty_security_measures: '아직 안전 조치가 추가되지 않았습니다.',
        empty_cleaning_protocols: '아직 청소 프로토콜이 추가되지 않았습니다.',
        empty_certifications: '아직 인증이 추가되지 않았습니다.',
        empty_start_message: '"추가"를 클릭하여 시작하십시오.',
        placeholder_security_title: '안전 조치 제목 입력',
        placeholder_protocol_title: '프로토콜 제목 입력',
        placeholder_certification_title: '인증 제목 입력',
        placeholder_security_description: '간단한 설명 입력 (최대 100자)',
        placeholder_protocol_description: '청소 프로토콜의 자세한 설명 입력',
      },
      orders_room_service: {
        title: '객실 주문',
        subtitle: '호텔 서비스 요청 관리',

        // 필터
        status: '상태',
        start_date: '시작일',
        end_date: '종료일',
        reservation_id: '예약 코드',
        post_id: '게시물 ID',
        service_type: '서비스 유형',
        search: '검색',
        clear_filters: '필터 지우기',

        // 상태
        status_pending: '대기 중',
        status_confirmed: '확인됨',
        status_in_progress: '진행 중',
        status_cancelled: '취소됨',
        status_concluded: '완료됨',
        status_completed: '완료됨',

        // 필터 옵션
        all_status: '모든 상태',
        all_types: '모든 유형',
        service_forms: '서비스 양식',
        services: '서비스',

        // 테이블 헤더
        service: '서비스',
        room: '객실',
        price: '가격',
        people_qty: '인원수',
        reservation: '예약',
        date: '날짜',
        time: '시간',
        priority: '우선순위',
        created_at: '생성일',
        actions: '작업',

        // 도구 설명 작업
        view_details: '세부 정보 보기',
        change_status: '상태 변경',

        // 세부 정보 모달
        order_details: '주문 세부 정보',
        close: '닫기',
        loading_details: '주문 세부 정보 로드 중...',
        loading: '로드 중...',

        // 주문 정보
        order: '주문',
        room_service: '룸 서비스',
        location: '위치',
        room_number: '객실 번호',
        scheduled_date: '예정 날짜',
        no_time: '시간 없음',
        reservation_id_label: '예약 코드',

        // 고객 정보
        customer_info: '고객 정보',
        full_name: '전체 이름',
        email: '이메일',
        phone: '전화',

        // 요청 세부 정보
        request_summary: '요청 요약',
        service_details: '서비스 세부사항',
        request_details: '요청 세부 정보',
        no_items_selected: '선택된 항목 없음',
        not_informed: '정보 없음',
        units: '단위',

        // 기술 정보
        technical_info: '기술 정보',
        post: '게시물',
        booking_type: '예약 유형',
        hotel_info: '호텔 정보',
        hotel_name: '호텔명',
        subdomain: '서브도메인',
        type: '유형',
        service_form: '서비스 양식',
        last_update: '최종 업데이트',
        additional_notes: '추가 비고',

        // 상태 변경 모달
        change_status_title: '상태 변경',
        current_status: '현재 상태',
        new_status: '새 상태',
        select_status: '상태 선택',

        // 플레이스홀더
        select_status_placeholder: '상태 선택',
        select_service_type_placeholder: '서비스 유형 선택',
        start_date_placeholder: '시작일',
        end_date_placeholder: '종료일',
        reservation_id_placeholder: '예약 ID 입력',
        post_id_placeholder: '게시물 ID 입력',
        new_status_placeholder: '새 상태 선택',

        // 오류 및 성공 메시지
        error: '오류',
        success: '성공',
        warning: '주의',
        error_loading_orders: '주문 로드 중 오류 발생!',
        error_loading_details: '주문 세부 정보 로드 중 오류 발생!',
        error_changing_status: '주문 상태 변경 중 오류 발생!',
        success_status_changed: '상태 변경 성공!',
        select_status_warning: '상태를 선택하십시오.',

        // 고객 리뷰
        customer_review: '고객 리뷰',
        rating: '평점',
        review_comment: '댓글',
      },
      s3Analytics: {
        title: 'S3 분석',
        startDate: '시작일',
        endDate: '종료일',
        pluginspaceId: 'Pluginspace ID',
        pluginspaceIdPlaceholder: 'Pluginspace ID 입력',
        method: '메서드',
        methodPlaceholder: '메서드 입력 (GET, POST 등)',
        loadData: '데이터 로드',
        generateAIAnalysis: 'AI 분석 생성',
        chatWithAI: 'AI와 대화',
        showRanking: '순위 표시',
        analyzeWithAI: 'AI로 분석',
        close: '닫기',
        totalRequests: '총 요청 수',
        totalCost: '총 비용',
        averageCostPerRequest: '요청당 평균 비용',
        consumptionByPluginspace: 'Pluginspace별 소비량',
        consumptionByMethod: '메서드별 소비량',
        consumptionByDate: '날짜별 소비량',
        costAnalysis: '비용 분석',
        aiAnalysis: 'AI 분석',
        chatMessage: '데이터에 대한 질문을 입력하십시오...',
        speakAnalysis: '분석 듣기',
        filterData: '데이터 필터링',
        noDataFound: '선택한 필터에 대한 데이터가 없습니다',
        errorLoadingData: '데이터 로드 중 오류 발생',
        errorGeneratingAnalysis: 'AI 분석 생성 중 오류 발생',
        analysisGenerated: '분석 생성 성공!',
        dataLoaded: '데이터 로드 성공!',
        rankingData: '순위 데이터',
        aiChatResponse: 'AI 응답',
        s3Analytics: 'S3 분석',
        filters: '필터',
        totalConsumption: '총 소비량',
        totalRecords: '총 기록 수',
        error: '오류',
        fetchError: 'S3 데이터 가져오기 중 오류 발생',
        aiAnalysisError: 'AI 분석 생성 중 오류 발생',
        aiChatError: 'AI와 대화 중 오류 발생',
        askQuestion: '데이터에 대한 질문을 입력하십시오...',
        ask: '질문',
        cancel: '취소',
        ok: '확인',
        aiResponse: 'AI 응답',
        aiAnalysisTitle: 'AI 분석',
        account: '계정',
        pluginspace: '상점',
        uniquePluginspaces: '고유 상점',
        methodDistribution: '메서드별 분포',
        timeAnalysis: '시간 분석',
        dataTable: '데이터 테이블',
        showingFirst10: '처음 10개 표시',
        of: '의',
        records: '기록',
        consumption: '소비량',
        cost: '비용',
        date: '날짜',
        allMethods: '모든 메서드',
        exportData: '데이터 내보내기',
      },
      hospitality_store: {
        establishment: '시설',
        select_establishment: '선택...',
        link: '링크',
        status: '상태',
        payment_integrated: '통합 결제',
        order: '순서',
        store_image: '상점 이미지',
        store_image_hint: '상점을 대표하는 이미지 선택',
        description: '설명',
        cnpj: 'CNPJ',
        code: '코드',
        store_id_placeholder: '상점 ID',
        type: '유형',
        store_type_placeholder: '시설 유형',
        no_store_found: '시설을 찾을 수 없습니다.',
        edit_store: '시설 편집',
        edit_store_subtitle: '시설 데이터 편집.',
      },
      stores_pages: {
        title: '시설',
        subtitle: '여기에 호텔 시설과 해당 작업이 나열됩니다.',
        create: '시설 생성',
        no_results: '시설을 찾을 수 없습니다.',
        table: {
          code: '코드',
          image: '이미지',
          name: '상점',
          cnpj: 'CNPJ',
          vinculation: '연결 유형',
          vinculation_default: '기본',
          vinculation_dynamic: '동적',
          type: '유형',
          order: '순서',
          status: '상태',
          status_active: '활성',
          status_inactive: '비활성',
          payment_integrated: '통합 결제',
          actions: '작업',
        },
        actions: {
          edit: '시설 편집',
          delete_confirm: '삭제하시겠습니까?',
          delete: '시설 삭제',
        },
        delete_success: '시설 삭제 성공.',
        delete_error: '시설 삭제 중 오류 발생. 다시 시도하십시오.',
        success: '성공!',
        error: '오류!',
      },
      stores_pages_create: {
        title: '시설 생성',
        subtitle: '호텔에 새 시설을 생성합니다.',
        form: {
          establishment: '시설',
          select_placeholder: '선택...',
          link: '링크',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: '상태',
          status_options: { active: '활성', inactive: '비활성' },
          payment_integrated: '통합 결제',
          payment_options: { active: '활성', inactive: '비활성' },
          order: '순서',
          image_label: '시설 이미지',
          image_smalltext: '시설을 대표하는 이미지 선택',
          description: '설명',
          info_title: '시설 정보',
          cnpj: 'CNPJ',
          code: '코드',
          type: '유형',
          vinculation_label: '연결 유형',
          vinculation_options: { default: '기본', dynamic: '동적' },
          empty_message: '시설을 찾을 수 없습니다.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: '상점 ID',
        },
        console_messages: {
          image_upload_error: '이미지 업로드 오류',
        },
        messages: {
          warning_title: '주의',
          select_store_warning: '저장하기 전에 유효한 시설을 선택하십시오.',
          error_saving: '시설 저장 중 오류가 발생했습니다. 다시 시도하십시오.',
          success_saved: '시설 저장 성공.',
        },
      },
      feedback_reviews: {
        title: '검색 및 만족도 리뷰',
        subtitle: '피드백 양식의 모든 평점 및 답변을 보고 관리합니다',
        breadcrumb_feedback: '만족도 피드백',
        error: '오류',
        success: '성공',
        loading: '로딩 중...',
        loading_details: '리뷰 상세 정보 로딩 중...',
        close: '닫기',
        error_loading_reviews: '리뷰를 로드하는 중 오류가 발생했습니다',
        error_loading_details: '리뷰 상세 정보를 로드하는 중 오류가 발생했습니다',
        error_changing_status: '리뷰 상태를 변경하는 중 오류가 발생했습니다',
        success_status_changed: '상태가 성공적으로 변경되었습니다',
        confirm_status_change: '상태 변경 확인',
        confirm_status_change_text: '이 리뷰의 상태를 변경하시겠습니까?',

        // 상태
        status_pending: '대기 중',
        status_approved: '승인됨',
        status_rejected: '거부됨',

        anonymous_active: '활성',
        anonymous_inactive: '비활성',

        // 필터
        filters: {
          feedback_form: '양식',
          status: '상태',
          anonymous: '익명',
          select_anonymous_placeholder: '모두',
          rating: '평점',
          reservation_id: '예약 ID',
          start_date: '시작일',
          end_date: '종료일',
          date: '날짜',
          all_forms: '모든 양식',
          all_status: '모든 상태',
          all_ratings: '모든 평점',
          select_form_placeholder: '양식 선택',
          select_status_placeholder: '상태 선택',
          select_rating_placeholder: '평점 선택',
          reservation_id_placeholder: '예약 ID 입력',
          start_date_placeholder: '시작일 선택',
          end_date_placeholder: '종료일 선택',
          filter_button: '필터링',
          clear_filters: '필터 지우기',
        },

        // 테이블
        table: {
          feedback_form: '양식',
          customer: '고객',
          room: '객실',
          reservation: '예약',
          rating: '평점',
          status: '상태',
          date: '날짜',
          time: '시간',
          actions: '작업',
        },

        // 작업
        actions: {
          view_details: '상세 보기',
          approve: '승인',
          reject: '거부',
        },

        // 리뷰 상세 정보
        review_details: '리뷰 상세 정보',
        room: '객실',
        reservation: '예약',
        feedback_form: '양식',
        responses: '답변',
        technical_info: '기술 정보',
        created_at: '생성일',
        updated_at: '업데이트일',
        review_id: '리뷰 ID',
        plugin_space_id: '플러그인 공간 ID',
        anonymous_response: '익명 답변',
        no_reservation_linked: '이 답변은 특정 예약에 연결되어 있지 않습니다',
        no_detailed_responses: '이 리뷰에 대한 상세 답변을 사용할 수 없습니다',
        // New keys added for feedback_reviews
        anonymous_label: '익명',
        email_anonymous: '익명 이메일',
        email_not_informed: '이메일 정보 없음',
        response_title: '응답',
        no_rating_provided: '평점 없음',
        no_items_selected: '선택된 항목 없음',
        no_option_selected: '선택된 옵션 없음',
        no_answer_provided: '응답 없음',
        form_label: '양식',
        client_not_identified: '고객 식별 불가',
        types: {
          title: '제목',
          text: '텍스트',
          textarea: '텍스트 영역',
          stars: '평점 (별)',
          checkbox: '체크박스',
          radio: '라디오',
          select: '선택 (리스트)',
          number: '숫자',
          date: '날짜',
          time: '시간',
          image: '이미지',
          link: '링크',
        },
      },
      stores_pages_edit: {
        title: '시설 편집',
        subtitle: '시설 데이터를 편집합니다.',
        form: {
          establishment: '시설',
          select_placeholder: '선택...',
          link: '링크',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: '상태',
          status_options: { active: '활성', inactive: '비활성' },
          payment_integrated: '통합 결제',
          payment_options: { active: '활성', inactive: '비활성' },
          order: '순서',
          image_label: '시설 이미지',
          image_smalltext: '시설을 대표하는 이미지 선택',
          description: '설명',
          info_title: '시설 정보',
          cnpj: 'CNPJ',
          code: '코드',
          type: '유형',
          vinculation_label: '연결 유형',
          vinculation_options: { default: '기본', dynamic: '동적' },
          empty_message: '시설을 찾을 수 없습니다.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: '상점 ID',
        },
        console_messages: {
          image_upload_error: '이미지 업로드 오류',
          image_remove_error: '저장 시 이미지 제거 중 오류 발생',
        },
        messages: {
          success_updated: '시설 업데이트 성공.',
          error_updating: '시설 업데이트 중 오류가 발생했습니다. 다시 시도하십시오.',
          payment_change_warning_title: '주의',
          payment_change_warning_text:
            '이 변경으로 인해 체크아웃 시 진행 중인 예약 금액이 변경될 수 있습니다.',
          payment_confirm: '예, 계속',
          cancel: '취소',
        },
      },
      hospitality_section: {
        index: {
          page_title: '게시 페이지',
          page_subtitle: '여기에 콘텐츠 게시 페이지와 각각의 작업이 나열되어 있습니다.',
          add_button: '게시 페이지 추가',
          filters: {
            sections: '게시 페이지',
          },
          table: {
            headers: {
              title: '제목',
              order: '순서',
              formTitle: '양식 제목',
              type: '유형',
              actions: '작업',
            },
          },
          actions: {
            edit: '게시 페이지 편집',
            delete: '게시 페이지 삭제',
          },
        },
        create: {
          page_title: '게시 페이지 생성',
          page_subtitle: '호텔용 새 콘텐츠 게시 페이지를 생성합니다.',
          add_button: '게시 페이지 추가',
          filters: {
            sections: '섹션',
          },
        },
        edit: {
          page_title: '게시 페이지 편집',
          page_subtitle: '콘텐츠 게시 페이지 데이터를 편집합니다.',
        },
        // 섹션의 동적 번역
        types: {
          category: '카테고리',
          content: '콘텐츠',
          simple: '단순',
          form: '양식',
          page: '레스토랑 및 매장',
        },
        status: {
          active: '활성',
          inactive: '비활성',
        },
        actions: {
          create: '생성',
          edit: '편집',
          delete: '삭제',
          save: '저장',
          cancel: '취소',
          update: '업데이트',
          remove_icon: '아이콘 제거',
          select_icon: '아이콘 선택',
        },
        fields: {
          title: '버튼 제목',
          type: '게시 페이지 유형',
          category: '카테고리',
          order: '순서',
          status: '상태',
          icon: '아이콘',
          icon_selected: '선택된 아이콘',
          icon_not_selected: '아이콘이 선택되지 않음',
          icon_description: '게시 페이지의 사이드 리스트에서 아이콘을 선택하세요',
          icon_change_description:
            '사이드 리스트에서 다른 아이콘을 선택하거나 현재 아이콘을 삭제하세요',
        },
        placeholders: {
          title: '버튼 제목을 입력하세요',
          type: '유형 선택',
          category: '카테고리 선택',
          order: '0',
          search_icon: '아이콘 검색...',
          all_categories: '모든 카테고리',
        },
        warnings: {
          stores:
            '동적 유형의 매장을 찾을 수 없습니다.\n계속하려면 설정 → 상점 및 시설로 이동하여 동적 유형의 매장을 구성하세요.',
        },
        messages: {
          validation: {
            title_required: '제목은 필수입니다!',
            category_required: '카테고리를 선택해 주세요!',
            icon_required: '아이콘을 선택해 주세요!',
          },
          success: {
            created: '게시 페이지가 성공적으로 생성되었습니다!',
            updated: '게시 페이지가 성공적으로 업데이트되었습니다!',
            deleted: '게시 페이지가 성공적으로 삭제되었습니다!',
          },
          error: {
            create: '게시 페이지 생성 중 오류가 발생했습니다!',
            update: '게시 페이지 업데이트 중 오류가 발생했습니다!',
            delete: '게시 페이지 삭제 중 오류가 발생했습니다!',
            load: '게시 페이지 데이터 로드 중 오류가 발생했습니다!',
          },
          confirm: {
            delete_title: '확실하신가요?',
            delete_text: '이 작업은 취소할 수 없습니다!',
            delete_confirm: '예, 삭제합니다',
            delete_cancel: '취소',
          },
          delete: {
            deleted_title: '게시 페이지 삭제',
            deleted_text: '삭제가 성공적으로 수행되었습니다!',
            error_title: '게시 페이지 삭제 중 오류 발생!',
            error_text: '게시 페이지 삭제 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
        },
      },
      hospitality_classification_post: {
        index: {
          page_title: '게시글 카테고리',
          page_subtitle: '여기에 게시글 카테고리와 각각의 작업이 나열되어 있습니다.',
          add_button: '게시글 카테고리 추가',
          filter_all: '전체',
          table: {
            headers: {
              title: '제목',
              image: '이미지',
              summary: '요약',
              status: '상태',
              classification: '분류',
              code: '코드',
              actions: '작업',
            },
            actions: {
              edit: '게시글 카테고리 편집',
              delete: '게시글 카테고리 삭제',
            },
          },
        },
        create: {
          page_title: '게시글 카테고리 생성',
          page_subtitle: '호텔용 새 게시글 카테고리를 생성합니다.',
          add_button: '게시글 카테고리 추가',
          success: {
            created_title: '게시글 카테고리가 생성되었습니다',
            created_text: '등록이 성공적으로 완료되었습니다!',
          },
          error: {
            created_title: '게시글 카테고리 생성 오류!',
            created_text: '카테고리 생성 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
        },
        edit: {
          page_title: '게시글 카테고리 편집',
          page_subtitle: '게시글 카테고리 데이터를 편집합니다.',
          error: {
            created_title: '게시글 카테고리 편집 오류!',
            created_text: '카테고리 편집 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
          success: {
            created_title: '게시글 카테고리 편집됨',
            created_text: '등록이 성공적으로 완료되었습니다!',
          },
        },
      },
      hospitality_post: {
        posts: '게시글',
        index: {
          page_title: '게시글',
          page_subtitle: '여기에 호텔 게시글이 각각의 액션과 함께 나열되어 있습니다.',
          add_button: '게시글 추가',
          filter_all: '전체',
          filter: '카테고리',
          table: {
            headers: {
              title: '제목',
              image: '이미지',
              summary: '요약',
              order: '순서',
              status: '상태',
              classification: '분류',
              actions: '액션',
            },
            actions: {
              edit: '게시글 편집',
              delete: '게시글 삭제',
            },
          },
        },
        create: {
          page_title: '게시글 생성',
          page_subtitle: '호텔을 위한 새로운 게시글을 생성합니다.',
          success: {
            created_title: '게시글이 생성되었습니다',
            created_text: '등록이 성공적으로 완료되었습니다!',
          },
          error: {
            created_title: '게시글 생성 오류!',
            created_text: '게시글 생성 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
        },
        edit: {
          page_title: '게시글 편집',
          page_subtitle: '게시글 데이터를 편집합니다.',
          success: {
            created_title: '게시글이 편집되었습니다',
            created_text: '등록이 성공적으로 완료되었습니다!',
          },
          error: {
            created_title: '게시글 편집 오류!',
            created_text: '게시글 편집 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
        },
        form_validate: {
          title_required: '제목은 필수입니다!',
          summary_required: '요약은 필수입니다!',
          classification_required: '분류는 필수입니다!',
          content_required: '내용은 필수입니다!',
          fields_missing: '모든 필드를 입력했는지 확인해 주세요!',
        },
      },
      hospitality_post_page: {
        types: {
          simple: '단순',
          section: '섹션',
          form: '폼',
          category: '카테고리',
        },
        index: {
          page_title: '게시 페이지',
          page_subtitle: '여기에 콘텐츠 게시 페이지와 각각의 액션이 나열되어 있습니다.',
          add_button: '게시 페이지 추가',
          edit_button: '게시 페이지 편집',
          delete_button: '게시 페이지 삭제',
        },
        create: {
          page_title: '게시 페이지 생성',
          page_subtitle: '호텔을 위한 새로운 콘텐츠 게시 페이지를 생성합니다.',
          form: {
            title: '게시 페이지 제목',
            type: '게시 페이지 유형',
            status: '상태',
          },
          icon: {
            icon: 'SVG 아이콘',
            lib: 'SVG 아이콘 라이브러리',
            search: '아이콘 검색...',
            category: '아이콘 카테고리',
            description: '게시 페이지의 사이드 리스트에서 아이콘을 선택하세요',
            selected: '선택된 아이콘',
            no_selected: '아이콘이 선택되지 않음',
            selected_description: '게시 페이지의 사이드 리스트에서 아이콘을 선택하세요',
            no_selected_description:
              '아이콘이 선택되지 않았습니다. 게시 페이지의 사이드 리스트에서 아이콘을 선택하세요',
            change_description:
              '사이드 리스트에서 다른 아이콘을 선택하거나 현재 아이콘을 삭제하세요',
          },
          success: {
            created_title: '게시 페이지 생성됨',
            created_text: '등록이 성공적으로 완료되었습니다!',
          },
          error: {
            created_title: '게시 페이지 생성 오류!',
            created_text: '페이지 생성 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
        },
        edit: {
          page_title: '게시 페이지 편집',
          page_subtitle: '콘텐츠 게시 페이지의 데이터를 편집합니다.',
          form: {
            title: '게시 페이지 제목',
            type: '게시 페이지 유형',
            status: '상태',
          },
          icon: {
            icon: 'SVG 아이콘',
            lib: 'SVG 아이콘 라이브러리',
            search: '아이콘 검색...',
            category: '아이콘 카테고리',
            description: '게시 페이지의 사이드 리스트에서 아이콘을 선택하세요',
            selected: '선택된 아이콘',
            no_selected: '아이콘이 선택되지 않음',
            selected_description: '게시 페이지의 사이드 리스트에서 아이콘을 선택하세요',
            no_selected_description:
              '아이콘이 선택되지 않았습니다. 게시 페이지의 사이드 리스트에서 아이콘을 선택하세요',
            change_description:
              '사이드 리스트에서 다른 아이콘을 선택하거나 현재 아이콘을 삭제하세요',
          },
          success: {
            created_title: '게시 페이지 편집됨',
            created_text: '편집이 성공적으로 완료되었습니다!',
          },
          error: {
            created_title: '게시 페이지 편집 오류!',
            created_text: '페이지 편집 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
        },
      },
      // Translations for Booking Hotel Services
      booking_hotel_services: {
        // Index page
        page_title: '서비스 예약',
        page_subtitle: '서비스 예약 관리',
        breadcrumb_services: '예약 서비스',
        breadcrumb_booking: '예약 서비스',
        create_button: '서비스 예약 생성',

        // Table headers
        table_image: '이미지',
        table_title: '제목',
        table_order: '순서',
        table_status: '상태',
        table_actions: '작업',

        // Table actions
        action_edit: '편집',
        action_delete: '삭제',

        // Status
        status_active: '활성',
        status_inactive: '비활성',

        // Messages
        delete_success: '예약이 삭제되었습니다',
        delete_error: '예약 삭제 오류',
        delete_confirm: '삭제를 확인하시겠습니까?',

        // Create page
        create_title: '서비스 예약 생성',
        create_subtitle: '새로운 서비스 예약을 생성하기 위해 정보를 입력하세요',

        // Edit page
        edit_title: '호텔 예약 편집',
        edit_subtitle: '예약 정보 편집',

        // Form fields
        field_title_label: '제목',
        field_title_placeholder: '예: 스파 예약',
        field_status_label: '상태',
        field_description_label: '설명',
        field_image_label: '이미지',
        field_icon_label: '아이콘',

        // Icon picker
        icon_choose: '아이콘 선택',
        icon_choose_modal: '아이콘 선택',

        // Day configuration
        day_config_title: '요일 설정',
        day_configure: '구성',
        day_periods_title: '시간대',
        day_period_add: '기간 추가',
        day_period_max: '최대 3개 기간',
        day_period_none: '기간이 구성되지 않았습니다. 최소 한 개의 기간을 추가하세요.',
        day_period_overlap: '시간대가 겹칠 수 없습니다. 설정한 시간을 조정하세요.',
        day_period_label: '기간',
        day_period_remove: '제거',
        day_interval_label: '간격 (분)',
        day_start_time_label: '시작 시간',
        day_end_time_label: '종료 시간',

        // Day names
        day_sunday: '일요일',
        day_monday: '월요일',
        day_tuesday: '화요일',
        day_wednesday: '수요일',
        day_thursday: '목요일',
        day_friday: '금요일',
        day_saturday: '토요일',

        // Grid selection
        grid_title: '연결된 그리드',
        grid_select: '그리드 선택',
        grid_selected: '개 그리드가 선택됨',
        grid_capacity: '용량',
        grid_multiple: '다중',
        grid_multiple_yes: '예',
        grid_multiple_no: '아니오',
        grid_status_active: '활성',
        grid_status_inactive: '비활성',

        // Action buttons
        button_back: '뒤로',
        button_save: '저장',
        button_update: '업데이트',
        button_create: '생성',
        button_cancel: '취소',
        button_confirm: '확인',

        // Validation messages
        validation_title_required: '필수 필드',
        validation_title_text: '제목은 필수입니다.',
        validation_icon_required: '필수 필드',
        validation_icon_text: '아이콘을 선택하세요.',
        validation_day_required: '설정 필요',
        validation_day_text: '최소 한 개의 요일을 설정하세요.',

        // Success messages
        success_created: '예약이 생성되었습니다',
        success_created_text: '예약이 성공적으로 생성되었습니다!',
        success_updated: '예약이 업데이트되었습니다',
        success_updated_text: '예약이 성공적으로 업데이트되었습니다!',

        // Error messages
        error_create: '생성 오류',
        error_create_text: '예약 생성 중 오류가 발생했습니다.',
        error_update: '업데이트 오류',
        error_update_text: '예약 업데이트 중 오류가 발생했습니다.',
        error_save: '오류',
        error_save_text: '예약 저장 중 오류가 발생했습니다.',
        error_load: '오류',
        error_load_text: '예약 데이터 로드 오류.',

        // Breadcrumbs
        breadcrumb_dashboard: '대시보드',
        breadcrumb_hospitality: '호스피탈리티',
        breadcrumb_hotel_reservations: '호텔 예약',
        breadcrumb_create: '생성',
        breadcrumb_edit: '편집',
      },
      users: {
        houserkeeping: '하우스키핑',
        maintenancetechnician: '유지보수 기술자',
        receptionist: '접수원',
        manager: '관리자',
        administrator: '관리자',
        waiter: '웨이터',
        kitchenchief: '주방장',
        warehouse: '창고 관리자',
        concierge: '컨시어지',
        messenger: '메신저',
        receptionsupervisor: '프런트 데스크 수퍼바이저',
        telephonist: '전화 교환원',
        cook: '요리사',
        barman: '바텐더',
        roomserviceattendant: '룸 서비스 직원',
        steward: '스튜어드',
        sommelier: '소믈리에',
        plumber: '배관공',
        airconditiontechnician: '에어컨 기술자',
        maintenancesupervisor: '유지보수 수퍼바이저',
        reservationagent: '예약 담당자',
        reservationcoordinator: '예약 코디네이터',
        salesexecutive: '영업 담당자',
        revenuemanager: '수익 관리자',
        commercialmanager: '상업 관리자',
        administrativeassistant: '행정 보조',
        financeaccountspayable: '재무 - 미지급금',
        accountant: '회계사',
        humanresources: '인사',
        purchasingwarehouse: '구매 및 창고',
        recreator: '레크리에이션 담당자',
        activityinstructor: '활동 강사',
        experiencecoordinator: '경험 코디네이터',
        tourguide: '관광 가이드',
        childmonitor: '어린이 모니터',
        securityguard: '경비원',
        doorman: '도어맨',
        accesscontroller: '출입 통제 담당자',
        securitysupervisor: '보안 수퍼바이저',
        generalmanager: '총 지배인',
        assistantmanager: '부지배인',
        operationalmanager: '운영 관리자',
        departmentsupervisorscoordinators: '부서 수퍼바이저 및 코디네이터',
        floormanager: '플로어 매니저',
        governancesupervisor: '하우스키핑 수퍼바이저',
        generalservicesassistant: '일반 서비스 보조',
        laundryattendant: '세탁 담당자',
        laundrymanager: '리네 관리자',
        machinist: '기계 조작자',
        ironer: '다림질 담당자',
        electrician: '전기 기술자',
        carpenter: '목수',
      },
      // Coreano (한국어 - ko)
      aggregador_publicity: {
        title: '어그리게이터 광고',
        subTitle: '광고를 관리합니다. 노출 기간, 순서 및 상태를 제어하세요.',
        title_create: '어그리게이터 광고 만들기',
        subTitle_create: 'pluginSpace용 새 어그리게이터 광고를 만듭니다.',
        title_edit: '어그리게이터 광고 수정',
        subTitle_edit: '어그리게이터 광고 데이터를 수정합니다.',
        table: {
          image: '이미지',
          title: '제목',
          description: '설명',
          periodo: '기간',
          name: '이름',
          order: '순서',
          status: '상태',
          actions: '작업',
        },
        form: {
          image_label: '이미지',
          title_label: '제목',
          category_label: '카테고리',
          category_placeholder: '카테고리를 선택하세요',
          local_label: '위치',
          local_placeholder: '위치를 선택하세요',
          description_label: '설명',
          start_date_label: '시작일',
          start_time_label: '시작 시간',
          end_date_label: '종료일',
          end_time_label: '종료 시간',
          external_link_checkbox: '외부 링크',
          external_link_placeholder: 'https://www.example.com',
          external_link_label: '링크',
          order_label: '순서',
          status_label: '상태',
          description_smalltext: '({qtd}자 제한)',
        },
        preview: {
          period_title: '기간',
          start: '시작',
          end: '종료',
          order: '순서',
        }
      },
      // Coreano (한국어 - ko)
      agregador_dinamic_page: {
        title: '어그리게이터 동적 페이지',
        subTitle: '어그리게이터 동적 페이지를 관리합니다. 순서와 상태를 제어하세요.',
        create_title: '어그리게이터 동적 페이지 만들기',
        create_subTitle: '새로운 어그리게이터 동적 페이지를 만듭니다.',
        edit_title: '어그리게이터 동적 페이지 수정',
        edit_subTitle: '어그리게이터 동적 페이지 데이터를 수정합니다.',
        tabs: {
          general: '페이지 메타데이터',
          general_title: '페이지 정보',
          general_description: '어그리게이터 동적 페이지의 일반 정보를 입력하세요.',
          grid: '정보 그리드',
          grid_title: '페이지 그리드',
          grid_description: '카드를 드래그하여 순서를 변경하세요.',
          grid_button: '그리드 추가',
          no_grid_message: '추가된 그리드가 없습니다. 새로운 그리드를 추가하려면 "그리드 추가"를 클릭하세요.',
          no_grid_title: '추가된 그리드 없음',
        },
        table: {
          image: '이미지',
          title: '제목',
          description: '설명',
          order: '순서',
          slug: '슬러그',
          grid_qtd: '그리드 수',
          status: '상태',
          actions: '작업',
        },
        form: {
          title_label: '제목',
          title_placeholder: '페이지 제목을 입력하세요',
          description_label: '설명',
          description_placeholder: '페이지 설명을 입력하세요',
          order_label: '순서',
          order_placeholder: '페이지 순서를 입력하세요',
          slug_label: '슬러그',
          slug_placeholder: '페이지 슬러그를 입력하세요',
          category_label: '카테고리',
          category_placeholder: '카테고리를 선택하세요',
          local_label: '위치',
          local_placeholder: '위치를 선택하세요',
          title_seo_label: 'SEO 제목',
          title_seo_placeholder: '페이지 SEO 제목을 입력하세요',
          share_image_label: '이미지',
          share_image_small_text: '이미지 크기는 720x600이어야 합니다',
          description_seo_label: 'SEO 설명',
          description_seo_placeholder: '페이지 SEO 설명을 입력하세요',
          status_label: '상태',
        },
        grid:{
          image: '이미지',
          carousel: '이미지 슬라이드 (최대 4개)',
          hero: 'Hero 섹션',
          content: '제목 + 텍스트 내용',
          text: '순수 텍스트',
        }
      },
    },
  },
}

export { messages }
// hospitality_experiences block moved inside translations below
